 
/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated type definitions for all form interfaces
 * Generated on: 2025-09-29T16:56:16.778Z
 *
 * Run 'npx ts-node src/utils/astFormTypeExtractor.ts' to regenerate
 */

/**
 * Comprehensive type definitions for all form interfaces
 * Maps form names to their field paths and types
 */
export const formTypeDefinitions: Record<string, Record<string, string>> = {
    "AMTItem": {
        "amount": "number",
        "code": "string",
        "description": "string"
    },
    "BalanceSheetData": {
        "assets": "object",
        "assets.lineEight": "number",
        "assets.lineEleven": "object",
        "assets.lineEleven.a": "number",
        "assets.lineEleven.b": "number",
        "assets.lineFifteen": "number",
        "assets.lineFive": "number",
        "assets.lineFour": "number",
        "assets.lineFourteen": "number",
        "assets.lineNine": "number",
        "assets.lineOne": "number",
        "assets.lineSeven": "number",
        "assets.lineSix": "number",
        "assets.lineTen": "object",
        "assets.lineTen.a": "number",
        "assets.lineTen.b": "number",
        "assets.lineThirteen": "object",
        "assets.lineThirteen.a": "number",
        "assets.lineThirteen.b": "number",
        "assets.lineThree": "number",
        "assets.lineTwelve": "number",
        "assets.lineTwo": "object",
        "assets.lineTwo.a": "number",
        "assets.lineTwo.b": "number",
        "liabilitiesAndCapital": "object",
        "liabilitiesAndCapital.lineEighteen": "number",
        "liabilitiesAndCapital.lineNineteen": "number",
        "liabilitiesAndCapital.lineSeventeen": "number",
        "liabilitiesAndCapital.lineSixteen": "number",
        "liabilitiesAndCapital.lineTwenty": "number",
        "liabilitiesAndCapital.lineTwentyFour": "number",
        "liabilitiesAndCapital.lineTwentyOne": "number",
        "liabilitiesAndCapital.lineTwentyThree": "number",
        "liabilitiesAndCapital.lineTwentyTwo": "number"
    },
    "BusinessCasualtyProperty": {
        "description": "string",
        "lineNineteen": "number",
        "lineTwenty": "number",
        "lineTwentyFour": "number",
        "lineTwentyOne": "number",
        "lineTwentyThree": "number",
        "lineTwentyTwo": "number",
        "propertyLetter": "literal"
    },
    "C_CorpBalanceSheetData": {
        "assets": "object",
        "assets.lineEight": "number",
        "assets.lineEleven": "object",
        "assets.lineEleven.a": "number",
        "assets.lineEleven.b": "number",
        "assets.lineFifteen": "number",
        "assets.lineFive": "number",
        "assets.lineFour": "number",
        "assets.lineFourteen": "number",
        "assets.lineNine": "number",
        "assets.lineOne": "number",
        "assets.lineSeven": "number",
        "assets.lineSix": "number",
        "assets.lineTen": "object",
        "assets.lineTen.a": "number",
        "assets.lineTen.b": "number",
        "assets.lineThirteen": "object",
        "assets.lineThirteen.a": "number",
        "assets.lineThirteen.b": "number",
        "assets.lineThree": "number",
        "assets.lineTwelve": "number",
        "assets.lineTwo": "object",
        "assets.lineTwo.a": "number",
        "assets.lineTwo.b": "number",
        "liabilitiesAndShareholdersEquity": "object",
        "liabilitiesAndShareholdersEquity.lineEighteen": "number",
        "liabilitiesAndShareholdersEquity.lineNineteen": "number",
        "liabilitiesAndShareholdersEquity.lineSeventeen": "number",
        "liabilitiesAndShareholdersEquity.lineSixteen": "number",
        "liabilitiesAndShareholdersEquity.lineTwenty": "number",
        "liabilitiesAndShareholdersEquity.lineTwentyEight": "number",
        "liabilitiesAndShareholdersEquity.lineTwentyFive": "number",
        "liabilitiesAndShareholdersEquity.lineTwentyFour": "number",
        "liabilitiesAndShareholdersEquity.lineTwentyNine": "number",
        "liabilitiesAndShareholdersEquity.lineTwentyOne": "number",
        "liabilitiesAndShareholdersEquity.lineTwentySeven": "number",
        "liabilitiesAndShareholdersEquity.lineTwentySix": "number",
        "liabilitiesAndShareholdersEquity.lineTwentyThree": "number",
        "liabilitiesAndShareholdersEquity.lineTwentyTwo": "number"
    },
    "C_CorpExpenseReconciliationItem": {
        "columnA": "number",
        "columnB": "number",
        "columnC": "number",
        "columnD": "number",
        "description": "string",
        "lineNumber": "string"
    },
    "C_CorpIncomeReconciliationItem": {
        "columnA": "number",
        "columnB": "number",
        "columnC": "number",
        "columnD": "number",
        "description": "string",
        "lineNumber": "string"
    },
    "CreditItem": {
        "amount": "number",
        "code": "string",
        "description": "string"
    },
    "DividendSource": {
        "adjustmentAmount": "number",
        "adjustmentDescription": "string",
        "amount": "number",
        "isCapitalGainDistribution": "boolean",
        "isForeignTaxPaid": "boolean",
        "isNomineeDistribution": "boolean",
        "isNondividendDistribution": "boolean",
        "payerName": "string"
    },
    "EstateOrTrust": {
        "ein": "string",
        "name": "string",
        "nonpassiveIncome": "number",
        "nonpassiveLoss": "number",
        "passiveDeduction": "number",
        "passiveIncome": "number",
        "passiveLoss": "number",
        "section179Deduction": "number"
    },
    "ExpenseReconciliationItem": {
        "columnA": "number",
        "columnB": "number",
        "columnC": "number",
        "columnD": "number",
        "description": "string",
        "lineNumber": "string"
    },
    "ForeignTransactionItem": {
        "amount": "number",
        "code": "string",
        "countryCode": "string",
        "description": "string"
    },
    "Form1040NRPageOneData": {
        "adjustments": "object",
        "adjustments.lineEleven": "number",
        "adjustments.lineTen": "number",
        "deductions": "object",
        "deductions.lineFifteen": "number",
        "deductions.lineFourteen": "number",
        "deductions.lineThirteen": "number",
        "deductions.lineTwelve": "object",
        "deductions.lineTwelve.amount": "number",
        "deductions.lineTwelve.itemized": "boolean",
        "header": "object",
        "header.address": "object",
        "header.address.aptNumber": "string",
        "header.address.city": "string",
        "header.address.foreignCountry": "string",
        "header.address.foreignPostalCode": "string",
        "header.address.foreignProvince": "string",
        "header.address.homeAddress": "string",
        "header.address.state": "string",
        "header.address.zipCode": "string",
        "header.digitalAssets": "boolean",
        "header.filingStatus": "literal",
        "header.spouseInfo": "object",
        "header.spouseInfo.firstName": "string",
        "header.spouseInfo.identificationNumber": "string",
        "header.spouseInfo.lastName": "string",
        "header.spouseInfo.middleInitial": "string",
        "header.taxYear": "number",
        "header.taxpayerInfo": "object",
        "header.taxpayerInfo.firstName": "string",
        "header.taxpayerInfo.identificationNumber": "string",
        "header.taxpayerInfo.lastName": "string",
        "header.taxpayerInfo.middleInitial": "string",
        "income": "object",
        "income.lineEight": "number",
        "income.lineFive": "object",
        "income.lineFive.a": "number",
        "income.lineFive.b": "number",
        "income.lineFour": "object",
        "income.lineFour.a": "number",
        "income.lineFour.b": "number",
        "income.lineNine": "number",
        "income.lineOne": "object",
        "income.lineOne.a": "number",
        "income.lineOne.b": "number",
        "income.lineOne.c": "number",
        "income.lineOne.d": "number",
        "income.lineOne.e": "number",
        "income.lineOne.f": "number",
        "income.lineOne.g": "number",
        "income.lineOne.h": "number",
        "income.lineOne.i": "number",
        "income.lineOne.z": "number",
        "income.lineSeven": "object",
        "income.lineSeven.amount": "number",
        "income.lineSeven.checkboxNotRequired": "boolean",
        "income.lineSix": "object",
        "income.lineSix.a": "number",
        "income.lineSix.b": "number",
        "income.lineThree": "object",
        "income.lineThree.a": "number",
        "income.lineThree.b": "number",
        "income.lineTwo": "object",
        "income.lineTwo.a": "number",
        "income.lineTwo.b": "number"
    },
    "Form1040NRPageTwoData": {
        "paidPreparer": "object",
        "paidPreparer.date": "string",
        "paidPreparer.firmAddress": "string",
        "paidPreparer.firmEin": "string",
        "paidPreparer.firmName": "string",
        "paidPreparer.firmPhone": "string",
        "paidPreparer.preparerName": "string",
        "paidPreparer.preparerSignature": "boolean",
        "paidPreparer.ptin": "string",
        "paidPreparer.selfEmployed": "boolean",
        "payments": "object",
        "payments.lineThirty": "null",
        "payments.lineThirtyOne": "number",
        "payments.lineThirtyThree": "number",
        "payments.lineThirtyTwo": "number",
        "payments.lineTwentyEight": "number",
        "payments.lineTwentyFive": "object",
        "payments.lineTwentyFive.a": "number",
        "payments.lineTwentyFive.b": "number",
        "payments.lineTwentyFive.c": "number",
        "payments.lineTwentyFive.d": "number",
        "payments.lineTwentyFive.e": "number",
        "payments.lineTwentyFive.f": "number",
        "payments.lineTwentyFive.g": "number",
        "payments.lineTwentyNine": "number",
        "payments.lineTwentySeven": "number",
        "payments.lineTwentySix": "number",
        "refundOrOwed": "object",
        "refundOrOwed.lineThirtyEight": "number",
        "refundOrOwed.lineThirtyFive": "object",
        "refundOrOwed.lineThirtyFive.accountNumber": "string",
        "refundOrOwed.lineThirtyFive.accountType": "literal",
        "refundOrOwed.lineThirtyFive.amount": "number",
        "refundOrOwed.lineThirtyFive.routingNumber": "string",
        "refundOrOwed.lineThirtyFour": "number",
        "refundOrOwed.lineThirtySeven": "number",
        "refundOrOwed.lineThirtySix": "number",
        "signature": "object",
        "signature.date": "string",
        "signature.daytimePhone": "string",
        "signature.emailAddress": "string",
        "signature.spouseDate": "string",
        "signature.spouseOccupation": "string",
        "signature.spouseSignature": "boolean",
        "signature.yourOccupation": "string",
        "signature.yourSignature": "boolean",
        "taxComputation": "object",
        "taxComputation.lineEighteen": "number",
        "taxComputation.lineNineteen": "number",
        "taxComputation.lineSeventeen": "number",
        "taxComputation.lineSixteen": "object",
        "taxComputation.lineSixteen.amount": "number",
        "taxComputation.lineSixteen.form4972": "boolean",
        "taxComputation.lineSixteen.form8814": "boolean",
        "taxComputation.lineSixteen.other": "boolean",
        "taxComputation.lineTwenty": "number",
        "taxComputation.lineTwentyFour": "number",
        "taxComputation.lineTwentyOne": "number",
        "taxComputation.lineTwentyThree": "object",
        "taxComputation.lineTwentyThree.a": "number",
        "taxComputation.lineTwentyThree.b": "number",
        "taxComputation.lineTwentyThree.c": "number",
        "taxComputation.lineTwentyThree.d": "number",
        "taxComputation.lineTwentyTwo": "number",
        "thirdPartyDesignee": "object",
        "thirdPartyDesignee.designeeName": "string",
        "thirdPartyDesignee.designeePhone": "string",
        "thirdPartyDesignee.personalIdentificationNumber": "string",
        "thirdPartyDesignee.wantToDiscuss": "boolean"
    },
    "Form1040PageOneData": {
        "dependents": "array",
        "dependents[]": "object",
        "dependents[].childTaxCredit": "boolean",
        "dependents[].creditForOtherDependents": "boolean",
        "dependents[].firstName": "string",
        "dependents[].lastName": "string",
        "dependents[].relationship": "string",
        "dependents[].socialSecurityNumber": "string",
        "filingStatus": "string",
        "header": "object",
        "header.address": "object",
        "header.address.aptNumber": "string",
        "header.address.city": "string",
        "header.address.homeAddress": "string",
        "header.address.state": "string",
        "header.address.zipcode": "string",
        "header.spouseInformation": "object",
        "header.spouseInformation.firstName": "string",
        "header.spouseInformation.lastName": "string",
        "header.spouseInformation.middleInitial": "string",
        "header.spouseInformation.socialSecurityNumber": "string",
        "header.taxPayerInformation": "object",
        "header.taxPayerInformation.firstName": "string",
        "header.taxPayerInformation.lastName": "string",
        "header.taxPayerInformation.middleInitial": "string",
        "header.taxPayerInformation.socialSecurityNumber": "string",
        "income": "object",
        "income.eight": "number",
        "income.eleven": "number",
        "income.fifteen": "number",
        "income.five": "object",
        "income.five.a": "number",
        "income.five.b": "number",
        "income.four": "object",
        "income.four.a": "number",
        "income.four.b": "number",
        "income.fourteen": "number",
        "income.nine": "number",
        "income.one": "object",
        "income.one.a": "number",
        "income.one.b": "number",
        "income.one.c": "number",
        "income.one.d": "number",
        "income.one.e": "number",
        "income.one.f": "number",
        "income.one.g": "number",
        "income.one.h": "number",
        "income.one.i": "number",
        "income.one.z": "number",
        "income.seven": "object",
        "income.seven.checked": "boolean",
        "income.seven.value": "number",
        "income.six": "object",
        "income.six.a": "number",
        "income.six.b": "number",
        "income.six.c": "boolean",
        "income.ten": "number",
        "income.thirteen": "number",
        "income.three": "object",
        "income.three.a": "number",
        "income.three.b": "number",
        "income.twelve": "number",
        "income.two": "object",
        "income.two.a": "number",
        "income.two.b": "number"
    },
    "Form1040PageTwoData": {
        "payments": "object",
        "payments.twentyfive": "object",
        "payments.twentyfive.a": "number",
        "payments.twentyfive.b": "number",
        "payments.twentyfive.c": "number",
        "payments.twentyfive.d": "number",
        "preparer": "object",
        "preparer.date": "string",
        "preparer.firmsAddress": "string",
        "preparer.firmsEin": "string",
        "preparer.firmsName": "string",
        "preparer.phoneNo": "string",
        "preparer.preparersName": "string",
        "preparer.preparersSignature": "boolean",
        "preparer.ptin": "string",
        "preparer.selfEmployed": "boolean",
        "taxAndCredits": "object",
        "taxAndCredits.eighteen": "number",
        "taxAndCredits.nineteen": "number",
        "taxAndCredits.seventeen": "number",
        "taxAndCredits.sixteen": "number",
        "taxAndCredits.twenty": "number",
        "taxAndCredits.twentyfour": "number",
        "taxAndCredits.twentyone": "number",
        "taxAndCredits.twentythree": "number",
        "taxAndCredits.twentytwo": "number",
        "taxYear": "number",
        "thirty": "number",
        "thirtyone": "number",
        "thirtythree": "number",
        "thirtytwo": "number",
        "twentyeight": "number",
        "twentynine": "number",
        "twentyseven": "number",
        "twentysix": "number"
    },
    "Form1040SRPageOneData": {
        "adjustments": "object",
        "adjustments.eleven": "number",
        "adjustments.ten": "number",
        "deductions": "object",
        "deductions.fifteen": "number",
        "deductions.fourteen": "number",
        "deductions.thirteen": "number",
        "deductions.twelve": "object",
        "deductions.twelve.amount": "number",
        "deductions.twelve.itemized": "boolean",
        "header": "object",
        "header.address": "object",
        "header.address.aptNumber": "string",
        "header.address.city": "string",
        "header.address.foreignCountry": "string",
        "header.address.foreignPostalCode": "string",
        "header.address.foreignProvince": "string",
        "header.address.homeAddress": "string",
        "header.address.state": "string",
        "header.address.zipcode": "string",
        "header.dependents": "array",
        "header.dependents[]": "object",
        "header.dependents[].childTaxCredit": "boolean",
        "header.dependents[].creditForOtherDependents": "boolean",
        "header.dependents[].firstName": "string",
        "header.dependents[].lastName": "string",
        "header.dependents[].relationship": "string",
        "header.dependents[].socialSecurityNumber": "string",
        "header.digitalAssets": "boolean",
        "header.filingStatus": "literal",
        "header.mfsSpouseName": "string",
        "header.mfsSpouseSSN": "string",
        "header.presidentialElectionCampaign": "object",
        "header.presidentialElectionCampaign.spouse": "boolean",
        "header.presidentialElectionCampaign.you": "boolean",
        "header.spouseInformation": "object",
        "header.spouseInformation.firstName": "string",
        "header.spouseInformation.lastName": "string",
        "header.spouseInformation.middleInitial": "string",
        "header.spouseInformation.socialSecurityNumber": "string",
        "header.standardDeduction": "object",
        "header.standardDeduction.someoneCanClaimSpouse": "boolean",
        "header.standardDeduction.someoneCanClaimYou": "boolean",
        "header.standardDeduction.spouse65OrOlder": "boolean",
        "header.standardDeduction.spouseBlind": "boolean",
        "header.standardDeduction.you65OrOlder": "boolean",
        "header.standardDeduction.youBlind": "boolean",
        "header.taxPayerInformation": "object",
        "header.taxPayerInformation.firstName": "string",
        "header.taxPayerInformation.lastName": "string",
        "header.taxPayerInformation.middleInitial": "string",
        "header.taxPayerInformation.socialSecurityNumber": "string",
        "income": "object",
        "income.eight": "number",
        "income.five": "object",
        "income.five.a": "number",
        "income.five.b": "number",
        "income.four": "object",
        "income.four.a": "number",
        "income.four.b": "number",
        "income.nine": "number",
        "income.one": "object",
        "income.one.a": "number",
        "income.one.b": "number",
        "income.one.c": "number",
        "income.one.d": "number",
        "income.one.e": "number",
        "income.one.f": "number",
        "income.one.g": "number",
        "income.one.h": "number",
        "income.one.i": "number",
        "income.one.z": "number",
        "income.seven": "object",
        "income.seven.amount": "number",
        "income.seven.checkboxNotRequired": "boolean",
        "income.six": "object",
        "income.six.a": "number",
        "income.six.b": "number",
        "income.three": "object",
        "income.three.a": "number",
        "income.three.b": "number",
        "income.two": "object",
        "income.two.a": "number",
        "income.two.b": "number"
    },
    "Form1040SRPageTwoData": {
        "paidPreparer": "object",
        "paidPreparer.date": "string",
        "paidPreparer.firmAddress": "string",
        "paidPreparer.firmEin": "string",
        "paidPreparer.firmName": "string",
        "paidPreparer.firmPhone": "string",
        "paidPreparer.preparerName": "string",
        "paidPreparer.preparerSignature": "boolean",
        "paidPreparer.ptin": "string",
        "paidPreparer.selfEmployed": "boolean",
        "payments": "object",
        "payments.thirty": "null",
        "payments.thirtyone": "number",
        "payments.thirtythree": "number",
        "payments.thirtytwo": "number",
        "payments.twentyeight": "number",
        "payments.twentyfive": "object",
        "payments.twentyfive.a": "number",
        "payments.twentyfive.b": "number",
        "payments.twentyfive.c": "number",
        "payments.twentyfive.d": "number",
        "payments.twentynine": "number",
        "payments.twentyseven": "number",
        "payments.twentysix": "number",
        "refundOrOwed": "object",
        "refundOrOwed.thirtyeight": "number",
        "refundOrOwed.thirtyfive": "object",
        "refundOrOwed.thirtyfive.a": "number",
        "refundOrOwed.thirtyfive.b_routingNumber": "string",
        "refundOrOwed.thirtyfive.c_accountType": "literal",
        "refundOrOwed.thirtyfive.d_accountNumber": "string",
        "refundOrOwed.thirtyfive.form8888Attached": "boolean",
        "refundOrOwed.thirtyfour": "number",
        "refundOrOwed.thirtyseven": "number",
        "refundOrOwed.thirtysix": "number",
        "signature": "object",
        "signature.date": "string",
        "signature.emailAddress": "string",
        "signature.identityProtectionPin": "string",
        "signature.phoneNumber": "string",
        "signature.spouseDate": "string",
        "signature.spouseIdentityProtectionPin": "string",
        "signature.spouseOccupation": "string",
        "signature.spouseSignature": "boolean",
        "signature.yourOccupation": "string",
        "signature.yourSignature": "boolean",
        "taxAndCredits": "object",
        "taxAndCredits.eighteen": "number",
        "taxAndCredits.nineteen": "number",
        "taxAndCredits.seventeen": "number",
        "taxAndCredits.sixteen": "object",
        "taxAndCredits.sixteen.amount": "number",
        "taxAndCredits.sixteen.form4972": "boolean",
        "taxAndCredits.sixteen.form8814": "boolean",
        "taxAndCredits.sixteen.other": "boolean",
        "taxAndCredits.twenty": "number",
        "taxAndCredits.twentyfour": "number",
        "taxAndCredits.twentyone": "number",
        "taxAndCredits.twentythree": "number",
        "taxAndCredits.twentytwo": "number",
        "thirdPartyDesignee": "object",
        "thirdPartyDesignee.designeeName": "string",
        "thirdPartyDesignee.designeePhone": "string",
        "thirdPartyDesignee.personalIdentificationNumber": "string",
        "thirdPartyDesignee.wantToDiscuss": "boolean"
    },
    "Form1065PageFiveData": {
        "scheduleL": "object",
        "scheduleL.beginningOfYear": "object",
        "scheduleL.endOfYear": "object",
        "scheduleM1": "object",
        "scheduleM1.lineEight": "number",
        "scheduleM1.lineFive": "number",
        "scheduleM1.lineFour": "number",
        "scheduleM1.lineNine": "number",
        "scheduleM1.lineOne": "number",
        "scheduleM1.lineSeven": "number",
        "scheduleM1.lineSix": "number",
        "scheduleM1.lineThree": "number",
        "scheduleM1.lineTwo": "number",
        "scheduleM2": "object",
        "scheduleM2.lineEight": "number",
        "scheduleM2.lineFive": "number",
        "scheduleM2.lineFour": "number",
        "scheduleM2.lineNine": "number",
        "scheduleM2.lineOne": "number",
        "scheduleM2.lineSeven": "number",
        "scheduleM2.lineSix": "number",
        "scheduleM2.lineTen": "number",
        "scheduleM2.lineThree": "number",
        "scheduleM2.lineTwo": "number"
    },
    "Form1065PageFourData": {
        "scheduleK": "object",
        "scheduleK.alternativeMinimumTax": "object",
        "scheduleK.alternativeMinimumTax.lineSeventeen": "object",
        "scheduleK.alternativeMinimumTax.lineSeventeen.a": "number",
        "scheduleK.alternativeMinimumTax.lineSeventeen.b": "number",
        "scheduleK.alternativeMinimumTax.lineSeventeen.c": "number",
        "scheduleK.alternativeMinimumTax.lineSeventeen.d": "number",
        "scheduleK.alternativeMinimumTax.lineSeventeen.e": "number",
        "scheduleK.credits": "object",
        "scheduleK.credits.lineFifteen": "number",
        "scheduleK.deductions": "object",
        "scheduleK.deductions.lineThirteen": "object",
        "scheduleK.deductions.lineThirteen.a": "number",
        "scheduleK.deductions.lineThirteen.b": "number",
        "scheduleK.deductions.lineThirteen.c": "number",
        "scheduleK.deductions.lineThirteen.d": "number",
        "scheduleK.deductions.lineTwelve": "number",
        "scheduleK.distributions": "object",
        "scheduleK.distributions.lineNineteen": "object",
        "scheduleK.distributions.lineNineteen.a": "number",
        "scheduleK.distributions.lineNineteen.b": "number",
        "scheduleK.foreign": "object",
        "scheduleK.foreign.lineSixteen": "object",
        "scheduleK.foreign.lineSixteen.a": "string",
        "scheduleK.foreign.lineSixteen.b": "number",
        "scheduleK.foreign.lineSixteen.c": "number",
        "scheduleK.income": "object",
        "scheduleK.income.lineEight": "number",
        "scheduleK.income.lineEleven": "number",
        "scheduleK.income.lineFive": "number",
        "scheduleK.income.lineFour": "number",
        "scheduleK.income.lineFourC": "number",
        "scheduleK.income.lineNine": "object",
        "scheduleK.income.lineNine.a": "number",
        "scheduleK.income.lineNine.b": "number",
        "scheduleK.income.lineNine.c": "number",
        "scheduleK.income.lineOne": "number",
        "scheduleK.income.lineSeven": "number",
        "scheduleK.income.lineSix": "number",
        "scheduleK.income.lineSixB": "number",
        "scheduleK.income.lineTen": "number",
        "scheduleK.income.lineThree": "object",
        "scheduleK.income.lineThree.a": "number",
        "scheduleK.income.lineThree.b": "number",
        "scheduleK.income.lineThree.c": "number",
        "scheduleK.income.lineTwo": "number",
        "scheduleK.otherInformation": "object",
        "scheduleK.otherInformation.lineTwenty": "object",
        "scheduleK.otherInformation.lineTwenty.a": "number",
        "scheduleK.otherInformation.lineTwenty.b": "number",
        "scheduleK.otherInformation.lineTwenty.c": "array",
        "scheduleK.otherInformation.lineTwenty.c[]": "object",
        "scheduleK.otherInformation.lineTwenty.c[].amount": "number",
        "scheduleK.otherInformation.lineTwenty.c[].description": "string",
        "scheduleK.selfEmployment": "object",
        "scheduleK.selfEmployment.lineFourteen": "object",
        "scheduleK.selfEmployment.lineFourteen.a": "number",
        "scheduleK.selfEmployment.lineFourteen.b": "number",
        "scheduleK.selfEmployment.lineFourteen.c": "number",
        "scheduleK.taxExempt": "object",
        "scheduleK.taxExempt.lineEighteen": "object",
        "scheduleK.taxExempt.lineEighteen.a": "number",
        "scheduleK.taxExempt.lineEighteen.b": "number",
        "scheduleK.taxExempt.lineEighteen.c": "number"
    },
    "Form1065PageOneData": {
        "checkBoxes": "object",
        "checkBoxes.a_DomesticGeneralPartnership": "boolean",
        "checkBoxes.b_DomesticLimitedPartnership": "boolean",
        "checkBoxes.c_DomesticLimitedLiabilityCompany": "boolean",
        "checkBoxes.d_DomesticLimitedLiabilityPartnership": "boolean",
        "checkBoxes.e_ForeignPartnership": "boolean",
        "checkBoxes.f_Other": "object",
        "checkBoxes.f_Other.checked": "boolean",
        "checkBoxes.f_Other.description": "string",
        "deductions": "object",
        "deductions.lineEighteen": "number",
        "deductions.lineEleven": "number",
        "deductions.lineFifteen": "number",
        "deductions.lineFourteen": "number",
        "deductions.lineNine": "number",
        "deductions.lineNineteen": "number",
        "deductions.lineSeventeen": "number",
        "deductions.lineSixteen": "object",
        "deductions.lineSixteen.a": "number",
        "deductions.lineSixteen.b": "number",
        "deductions.lineTen": "number",
        "deductions.lineThirteen": "number",
        "deductions.lineTwelve": "number",
        "deductions.lineTwenty": "number",
        "deductions.lineTwentyOne": "number",
        "header": "object",
        "header.addressChange": "boolean",
        "header.addressNumber": "string",
        "header.addressStreet": "string",
        "header.amendedReturn": "boolean",
        "header.businessCode": "string",
        "header.cityStateZip": "string",
        "header.dateBusinessStarted": "string",
        "header.ein": "string",
        "header.finalReturn": "boolean",
        "header.initialReturn": "boolean",
        "header.name": "string",
        "header.nameChange": "boolean",
        "header.principalBusinessActivity": "string",
        "header.principalProductOrService": "string",
        "header.totalPartners": "number",
        "income": "object",
        "income.lineEight": "number",
        "income.lineFive": "number",
        "income.lineFour": "number",
        "income.lineOne": "object",
        "income.lineOne.a": "number",
        "income.lineOne.b": "number",
        "income.lineOne.c": "number",
        "income.lineSeven": "number",
        "income.lineSix": "number",
        "income.lineThree": "number",
        "income.lineTwo": "number",
        "lineTwentyTwo": "number"
    },
    "Form1065PageThreeData": {
        "scheduleB": "object",
        "scheduleB.lineEight": "boolean",
        "scheduleB.lineEighteen": "boolean",
        "scheduleB.lineEleven": "boolean",
        "scheduleB.lineFifteen": "boolean",
        "scheduleB.lineFive": "string",
        "scheduleB.lineFour": "boolean",
        "scheduleB.lineFourteen": "boolean",
        "scheduleB.lineNine": "boolean",
        "scheduleB.lineNineteen": "boolean",
        "scheduleB.lineOne": "string",
        "scheduleB.lineSevenA": "boolean",
        "scheduleB.lineSevenB": "array",
        "scheduleB.lineSevenB[]": "string",
        "scheduleB.lineSeventeen": "boolean",
        "scheduleB.lineSix": "boolean",
        "scheduleB.lineSixteen": "boolean",
        "scheduleB.lineTen": "boolean",
        "scheduleB.lineThirteen": "boolean",
        "scheduleB.lineThree": "boolean",
        "scheduleB.lineTwelve": "boolean",
        "scheduleB.lineTwenty": "boolean",
        "scheduleB.lineTwo": "string"
    },
    "Form1065PageTwoData": {
        "scheduleA": "object",
        "scheduleA.lineEight": "number",
        "scheduleA.lineFive": "number",
        "scheduleA.lineFour": "number",
        "scheduleA.lineNine": "object",
        "scheduleA.lineNine.a_CostMethod": "boolean",
        "scheduleA.lineNine.b_LowerOfCostOrMarket": "boolean",
        "scheduleA.lineNine.c_Other": "object",
        "scheduleA.lineNine.c_Other.checked": "boolean",
        "scheduleA.lineNine.c_Other.description": "string",
        "scheduleA.lineOne": "number",
        "scheduleA.lineSeven": "number",
        "scheduleA.lineSix": "number",
        "scheduleA.lineTen": "boolean",
        "scheduleA.lineThree": "number",
        "scheduleA.lineTwo": "number",
        "taxAndPayment": "object",
        "taxAndPayment.lineTwentyFive": "number",
        "taxAndPayment.lineTwentyFour": "number",
        "taxAndPayment.lineTwentySix": "number",
        "taxAndPayment.lineTwentyThree": "number"
    },
    "Form1120PageFiveData": {
        "scheduleM1": "object",
        "scheduleM1.lineEight": "number",
        "scheduleM1.lineFive": "number",
        "scheduleM1.lineFour": "number",
        "scheduleM1.lineNine": "number",
        "scheduleM1.lineOne": "number",
        "scheduleM1.lineSeven": "number",
        "scheduleM1.lineSix": "number",
        "scheduleM1.lineTen": "number",
        "scheduleM1.lineThree": "number",
        "scheduleM1.lineTwo": "number",
        "scheduleM2": "object",
        "scheduleM2.lineEight": "number",
        "scheduleM2.lineFive": "object",
        "scheduleM2.lineFive.a": "number",
        "scheduleM2.lineFive.b": "number",
        "scheduleM2.lineFive.c": "number",
        "scheduleM2.lineFour": "number",
        "scheduleM2.lineOne": "number",
        "scheduleM2.lineSeven": "number",
        "scheduleM2.lineSix": "number",
        "scheduleM2.lineThree": "number",
        "scheduleM2.lineTwo": "number"
    },
    "Form1120PageFourData": {
        "scheduleL": "object",
        "scheduleL.beginningOfTaxYear": "object",
        "scheduleL.endOfTaxYear": "object"
    },
    "Form1120PageOneData": {
        "deductions": "object",
        "deductions.lineEighteen": "number",
        "deductions.lineFifteen": "number",
        "deductions.lineFourteen": "number",
        "deductions.lineNineteen": "number",
        "deductions.lineSeventeen": "number",
        "deductions.lineSixteen": "number",
        "deductions.lineThirteen": "number",
        "deductions.lineTwelve": "number",
        "deductions.lineTwenty": "number",
        "deductions.lineTwentyFive": "number",
        "deductions.lineTwentyFour": "number",
        "deductions.lineTwentyOne": "number",
        "deductions.lineTwentySeven": "number",
        "deductions.lineTwentySix": "number",
        "deductions.lineTwentyThree": "number",
        "deductions.lineTwentyTwo": "number",
        "header": "object",
        "header.addressChange": "boolean",
        "header.addressNumber": "string",
        "header.addressStreet": "string",
        "header.amendedReturn": "boolean",
        "header.checkBoxes": "object",
        "header.checkBoxes.a_ConsolidatedReturn": "boolean",
        "header.checkBoxes.b_PersonalHoldingCo": "boolean",
        "header.checkBoxes.c_PersonalServiceCorp": "boolean",
        "header.checkBoxes.d_ScheduleM3Attached": "boolean",
        "header.cityStateZip": "string",
        "header.dateIncorporated": "string",
        "header.ein": "string",
        "header.finalReturn": "boolean",
        "header.initialReturn": "boolean",
        "header.name": "string",
        "header.nameChange": "boolean",
        "header.totalAssets": "number",
        "income": "object",
        "income.lineEight": "number",
        "income.lineEleven": "number",
        "income.lineFive": "number",
        "income.lineFour": "number",
        "income.lineNine": "number",
        "income.lineOne": "object",
        "income.lineOne.a": "number",
        "income.lineOne.b": "number",
        "income.lineOne.c": "number",
        "income.lineSeven": "number",
        "income.lineSix": "number",
        "income.lineTen": "number",
        "income.lineThree": "number",
        "income.lineTwo": "number",
        "lineThirty": "number",
        "lineTwentyEight": "number",
        "lineTwentyNine": "object",
        "lineTwentyNine.a": "number",
        "lineTwentyNine.b": "number",
        "lineTwentyNine.c": "number"
    },
    "Form1120PageSixData": {
        "additionalSchedules": "object",
        "additionalSchedules.otherSchedules": "array",
        "additionalSchedules.otherSchedules[]": "string",
        "additionalSchedules.scheduleM3": "boolean",
        "additionalSchedules.scheduleUTP": "boolean"
    },
    "Form1120PageThreeData": {
        "scheduleJ": "object",
        "scheduleJ.partOne": "object",
        "scheduleJ.partOne.lineEight": "number",
        "scheduleJ.partOne.lineEleven": "number",
        "scheduleJ.partOne.lineFive": "number",
        "scheduleJ.partOne.lineFour": "number",
        "scheduleJ.partOne.lineNine": "number",
        "scheduleJ.partOne.lineOne": "number",
        "scheduleJ.partOne.lineSeven": "number",
        "scheduleJ.partOne.lineSix": "number",
        "scheduleJ.partOne.lineTen": "number",
        "scheduleJ.partOne.lineThree": "number",
        "scheduleJ.partOne.lineTwo": "number",
        "scheduleJ.partTwo": "object",
        "scheduleJ.partTwo.lineFifteen": "number",
        "scheduleJ.partTwo.lineFourteen": "number",
        "scheduleJ.partTwo.lineSeventeen": "number",
        "scheduleJ.partTwo.lineSixteen": "number",
        "scheduleJ.partTwo.lineThirteen": "number",
        "scheduleJ.partTwo.lineTwelve": "number",
        "scheduleK": "object",
        "scheduleK.lineEight": "boolean",
        "scheduleK.lineEleven": "boolean",
        "scheduleK.lineFifteen": "boolean",
        "scheduleK.lineFive": "object",
        "scheduleK.lineFive.a": "boolean",
        "scheduleK.lineFive.b": "array",
        "scheduleK.lineFive.b[]": "string",
        "scheduleK.lineFour": "string",
        "scheduleK.lineFourteen": "number",
        "scheduleK.lineNine": "boolean",
        "scheduleK.lineOne": "string",
        "scheduleK.lineSeven": "boolean",
        "scheduleK.lineSeventeen": "boolean",
        "scheduleK.lineSix": "boolean",
        "scheduleK.lineSixteen": "boolean",
        "scheduleK.lineTen": "boolean",
        "scheduleK.lineThirteen": "string",
        "scheduleK.lineThree": "string",
        "scheduleK.lineTwelve": "boolean",
        "scheduleK.lineTwo": "string"
    },
    "Form1120PageTwoData": {
        "scheduleC": "object",
        "scheduleC.deductions": "object",
        "scheduleC.deductions.lineNineteen": "number",
        "scheduleC.deductions.lineTwenty": "number",
        "scheduleC.deductions.lineTwentyOne": "number",
        "scheduleC.deductions.lineTwentyTwo": "number",
        "scheduleC.dividends": "object",
        "scheduleC.dividends.lineEight": "number",
        "scheduleC.dividends.lineEighteen": "number",
        "scheduleC.dividends.lineEleven": "number",
        "scheduleC.dividends.lineFifteen": "number",
        "scheduleC.dividends.lineFive": "number",
        "scheduleC.dividends.lineFour": "number",
        "scheduleC.dividends.lineFourteen": "number",
        "scheduleC.dividends.lineNine": "number",
        "scheduleC.dividends.lineOne": "number",
        "scheduleC.dividends.lineSeven": "number",
        "scheduleC.dividends.lineSeventeen": "number",
        "scheduleC.dividends.lineSix": "number",
        "scheduleC.dividends.lineSixteen": "number",
        "scheduleC.dividends.lineTen": "number",
        "scheduleC.dividends.lineThirteen": "number",
        "scheduleC.dividends.lineThree": "number",
        "scheduleC.dividends.lineTwelve": "number",
        "scheduleC.dividends.lineTwo": "number",
        "scheduleC.lineTwentyFour": "number",
        "scheduleC.lineTwentyThree": "number",
        "taxComputationAndPayments": "object",
        "taxComputationAndPayments.lineThirtyFive": "number",
        "taxComputationAndPayments.lineThirtyFour": "number",
        "taxComputationAndPayments.lineThirtyOne": "number",
        "taxComputationAndPayments.lineThirtySeven": "object",
        "taxComputationAndPayments.lineThirtySeven.creditedToEstimatedTax": "number",
        "taxComputationAndPayments.lineThirtySeven.refunded": "number",
        "taxComputationAndPayments.lineThirtySix": "number",
        "taxComputationAndPayments.lineThirtyThree": "number",
        "taxComputationAndPayments.lineThirtyTwo": "number"
    },
    "Form1120SPageFiveData": {
        "scheduleM2": "object",
        "scheduleM2.accumulatedAdjustments": "object",
        "scheduleM2.accumulatedAdjustments.lineEight": "number",
        "scheduleM2.accumulatedAdjustments.lineFive": "number",
        "scheduleM2.accumulatedAdjustments.lineFour": "number",
        "scheduleM2.accumulatedAdjustments.lineOne": "number",
        "scheduleM2.accumulatedAdjustments.lineSeven": "number",
        "scheduleM2.accumulatedAdjustments.lineSix": "number",
        "scheduleM2.accumulatedAdjustments.lineThree": "number",
        "scheduleM2.accumulatedAdjustments.lineTwo": "number",
        "scheduleM2.accumulatedEarningsAndProfits": "object",
        "scheduleM2.accumulatedEarningsAndProfits.lineFive": "number",
        "scheduleM2.accumulatedEarningsAndProfits.lineFour": "number",
        "scheduleM2.accumulatedEarningsAndProfits.lineOne": "number",
        "scheduleM2.accumulatedEarningsAndProfits.lineThree": "number",
        "scheduleM2.accumulatedEarningsAndProfits.lineTwo": "number",
        "scheduleM2.otherAdjustmentsAccount": "object",
        "scheduleM2.otherAdjustmentsAccount.lineFour": "number",
        "scheduleM2.otherAdjustmentsAccount.lineOne": "number",
        "scheduleM2.otherAdjustmentsAccount.lineThree": "number",
        "scheduleM2.otherAdjustmentsAccount.lineTwo": "number",
        "scheduleM2.shareholdersUndistributedTaxableIncome": "object",
        "scheduleM2.shareholdersUndistributedTaxableIncome.lineFour": "number",
        "scheduleM2.shareholdersUndistributedTaxableIncome.lineOne": "number",
        "scheduleM2.shareholdersUndistributedTaxableIncome.lineThree": "number",
        "scheduleM2.shareholdersUndistributedTaxableIncome.lineTwo": "number"
    },
    "Form1120SPageFourData": {
        "scheduleL": "object",
        "scheduleL.beginningOfTaxYear": "object",
        "scheduleL.endOfTaxYear": "object",
        "scheduleM1": "object",
        "scheduleM1.lineEight": "number",
        "scheduleM1.lineFive": "number",
        "scheduleM1.lineFour": "number",
        "scheduleM1.lineOne": "number",
        "scheduleM1.lineSeven": "number",
        "scheduleM1.lineSix": "number",
        "scheduleM1.lineThree": "number",
        "scheduleM1.lineTwo": "number"
    },
    "Form1120SPageOneData": {
        "deductions": "object",
        "deductions.lineEight": "number",
        "deductions.lineEighteen": "number",
        "deductions.lineEleven": "number",
        "deductions.lineFifteen": "number",
        "deductions.lineFourteen": "object",
        "deductions.lineFourteen.a": "number",
        "deductions.lineFourteen.b": "number",
        "deductions.lineNine": "number",
        "deductions.lineNineteen": "number",
        "deductions.lineSeven": "number",
        "deductions.lineSeventeen": "number",
        "deductions.lineSixteen": "number",
        "deductions.lineTen": "number",
        "deductions.lineThirteen": "number",
        "deductions.lineTwelve": "number",
        "deductions.lineTwenty": "number",
        "header": "object",
        "header.addressNumber": "string",
        "header.addressStreet": "string",
        "header.businessActivity": "string",
        "header.businessActivityCode": "string",
        "header.checkBoxes": "object",
        "header.checkBoxes.a_FinalReturn": "boolean",
        "header.checkBoxes.b_NameChange": "boolean",
        "header.checkBoxes.c_AddressChange": "boolean",
        "header.checkBoxes.d_AmendedReturn": "boolean",
        "header.checkBoxes.e_InitialReturn": "boolean",
        "header.checkBoxes.f_TerminatedElection": "boolean",
        "header.cityStateZip": "string",
        "header.dateIncorporated": "string",
        "header.effectiveDateOfElection": "string",
        "header.ein": "string",
        "header.name": "string",
        "header.numberOfShareholders": "number",
        "header.productOrService": "string",
        "header.sElectionTerminated": "boolean",
        "header.totalAssets": "number",
        "income": "object",
        "income.lineFive": "number",
        "income.lineFour": "number",
        "income.lineOne": "object",
        "income.lineOne.a": "number",
        "income.lineOne.b": "number",
        "income.lineOne.c": "number",
        "income.lineSix": "number",
        "income.lineThree": "number",
        "income.lineTwo": "number",
        "taxAndPayments": "object",
        "taxAndPayments.lineTwentyFive": "number",
        "taxAndPayments.lineTwentyFour": "number",
        "taxAndPayments.lineTwentyOne": "number",
        "taxAndPayments.lineTwentySeven": "number",
        "taxAndPayments.lineTwentySix": "number",
        "taxAndPayments.lineTwentyThree": "object",
        "taxAndPayments.lineTwentyThree.a": "number",
        "taxAndPayments.lineTwentyThree.b": "number",
        "taxAndPayments.lineTwentyThree.c": "number",
        "taxAndPayments.lineTwentyThree.d": "number",
        "taxAndPayments.lineTwentyThree.e": "number",
        "taxAndPayments.lineTwentyTwo": "object",
        "taxAndPayments.lineTwentyTwo.a": "number",
        "taxAndPayments.lineTwentyTwo.b": "number",
        "taxAndPayments.lineTwentyTwo.c": "number"
    },
    "Form1120SPageThreeData": {
        "scheduleK": "object",
        "scheduleK.alternativeMinimumTax": "object",
        "scheduleK.alternativeMinimumTax.lineFifteen": "object",
        "scheduleK.alternativeMinimumTax.lineFifteen.items": "array",
        "scheduleK.alternativeMinimumTax.lineFifteen.items[]": "object",
        "scheduleK.credits": "object",
        "scheduleK.credits.lineThirteen": "object",
        "scheduleK.credits.lineThirteen.items": "array",
        "scheduleK.credits.lineThirteen.items[]": "object",
        "scheduleK.deductions": "object",
        "scheduleK.deductions.lineEleven": "number",
        "scheduleK.deductions.lineTwelve": "object",
        "scheduleK.deductions.lineTwelve.a": "number",
        "scheduleK.deductions.lineTwelve.b": "number",
        "scheduleK.deductions.lineTwelve.c": "number",
        "scheduleK.deductions.lineTwelve.d": "object",
        "scheduleK.deductions.lineTwelve.d.items": "array",
        "scheduleK.deductions.lineTwelve.d.items[]": "object",
        "scheduleK.foreign": "object",
        "scheduleK.foreign.lineFourteen": "object",
        "scheduleK.foreign.lineFourteen.items": "array",
        "scheduleK.foreign.lineFourteen.items[]": "object",
        "scheduleK.income": "object",
        "scheduleK.income.lineEight": "object",
        "scheduleK.income.lineEight.a": "number",
        "scheduleK.income.lineEight.b": "number",
        "scheduleK.income.lineEight.c": "number",
        "scheduleK.income.lineFive": "object",
        "scheduleK.income.lineFive.a": "number",
        "scheduleK.income.lineFive.b": "number",
        "scheduleK.income.lineFour": "number",
        "scheduleK.income.lineNine": "number",
        "scheduleK.income.lineOne": "number",
        "scheduleK.income.lineSeven": "number",
        "scheduleK.income.lineSix": "number",
        "scheduleK.income.lineTen": "object",
        "scheduleK.income.lineTen.items": "array",
        "scheduleK.income.lineTen.items[]": "object",
        "scheduleK.income.lineThree": "object",
        "scheduleK.income.lineThree.a": "number",
        "scheduleK.income.lineThree.b": "number",
        "scheduleK.income.lineThree.c": "number",
        "scheduleK.income.lineTwo": "number",
        "scheduleK.itemsAffectingShareholderBasis": "object",
        "scheduleK.itemsAffectingShareholderBasis.lineSixteen": "object",
        "scheduleK.itemsAffectingShareholderBasis.lineSixteen.a": "number",
        "scheduleK.itemsAffectingShareholderBasis.lineSixteen.b": "number",
        "scheduleK.itemsAffectingShareholderBasis.lineSixteen.c": "number",
        "scheduleK.itemsAffectingShareholderBasis.lineSixteen.d": "object",
        "scheduleK.itemsAffectingShareholderBasis.lineSixteen.d.cash": "number",
        "scheduleK.itemsAffectingShareholderBasis.lineSixteen.d.property": "number",
        "scheduleK.itemsAffectingShareholderBasis.lineSixteen.e": "number",
        "scheduleK.otherInformation": "object",
        "scheduleK.otherInformation.lineSeventeen": "object",
        "scheduleK.otherInformation.lineSeventeen.items": "array",
        "scheduleK.otherInformation.lineSeventeen.items[]": "object"
    },
    "Form1120SPageTwoData": {
        "scheduleA": "object",
        "scheduleA.lineEight": "number",
        "scheduleA.lineFive": "number",
        "scheduleA.lineFour": "number",
        "scheduleA.lineNine": "object",
        "scheduleA.lineNine.a_CostMethod": "boolean",
        "scheduleA.lineNine.b_LowerOfCostOrMarket": "boolean",
        "scheduleA.lineNine.c_Other": "object",
        "scheduleA.lineNine.c_Other.checked": "boolean",
        "scheduleA.lineNine.c_Other.description": "string",
        "scheduleA.lineOne": "number",
        "scheduleA.lineSeven": "number",
        "scheduleA.lineSix": "number",
        "scheduleA.lineTen": "object",
        "scheduleA.lineTen.a_SubnormalGoods": "boolean",
        "scheduleA.lineTen.b_LIFO": "boolean",
        "scheduleA.lineThree": "number",
        "scheduleA.lineTwo": "number",
        "scheduleB": "object",
        "scheduleB.lineEight": "boolean",
        "scheduleB.lineEleven": "number",
        "scheduleB.lineFifteen": "boolean",
        "scheduleB.lineFive": "boolean",
        "scheduleB.lineFour": "object",
        "scheduleB.lineFour.a": "boolean",
        "scheduleB.lineFour.b": "string",
        "scheduleB.lineFour.c": "string",
        "scheduleB.lineFourteen": "boolean",
        "scheduleB.lineNine": "string",
        "scheduleB.lineOne": "string",
        "scheduleB.lineSeven": "boolean",
        "scheduleB.lineSix": "boolean",
        "scheduleB.lineSixteen": "boolean",
        "scheduleB.lineTen": "number",
        "scheduleB.lineThirteen": "boolean",
        "scheduleB.lineThree": "boolean",
        "scheduleB.lineTwelve": "boolean",
        "scheduleB.lineTwo": "string"
    },
    "Form1125EPageOneData": {
        "header": "object",
        "header.ein": "string",
        "header.name": "string",
        "noteSection": "object",
        "noteSection.totalAssetsUnder500K": "boolean",
        "noteSection.totalReceiptsUnder500K": "boolean",
        "officers": "array",
        "officers[]": "object",
        "totals": "object",
        "totals.lineFour": "number",
        "totals.lineThree": "number",
        "totals.lineTwo": "number"
    },
    "Form4562PageOneData": {
        "header": "object",
        "header.businessName": "string",
        "header.identifyingNumber": "string",
        "header.name": "string",
        "partFour": "object",
        "partFour.lineTwentyThree": "number",
        "partOne": "object",
        "partOne.lineEight": "number",
        "partOne.lineEleven": "number",
        "partOne.lineFive": "number",
        "partOne.lineFour": "number",
        "partOne.lineNine": "number",
        "partOne.lineOne": "number",
        "partOne.lineSeven": "number",
        "partOne.lineSix": "array",
        "partOne.lineSix[]": "object",
        "partOne.lineSix[].cost": "number",
        "partOne.lineSix[].description": "string",
        "partOne.lineSix[].electedCost": "number",
        "partOne.lineTen": "number",
        "partOne.lineThirteen": "number",
        "partOne.lineThree": "number",
        "partOne.lineTwelve": "number",
        "partOne.lineTwo": "number",
        "partThree": "object",
        "partThree.lineTwentyOne": "number",
        "partThree.lineTwentyTwo": "number",
        "partThree.sectionA": "object",
        "partThree.sectionA.lineEighteen": "boolean",
        "partThree.sectionA.lineSeventeen": "number",
        "partThree.sectionB": "object",
        "partThree.sectionB.lineNineteen": "object",
        "partThree.sectionB.lineNineteen.a": "object",
        "partThree.sectionB.lineNineteen.a.basis": "number",
        "partThree.sectionB.lineNineteen.a.convention": "string",
        "partThree.sectionB.lineNineteen.a.depreciation": "number",
        "partThree.sectionB.lineNineteen.a.method": "string",
        "partThree.sectionB.lineNineteen.a.monthYearPlaced": "string",
        "partThree.sectionB.lineNineteen.a.recoveryPeriod": "string",
        "partThree.sectionB.lineNineteen.b": "object",
        "partThree.sectionB.lineNineteen.b.basis": "number",
        "partThree.sectionB.lineNineteen.b.convention": "string",
        "partThree.sectionB.lineNineteen.b.depreciation": "number",
        "partThree.sectionB.lineNineteen.b.method": "string",
        "partThree.sectionB.lineNineteen.b.monthYearPlaced": "string",
        "partThree.sectionB.lineNineteen.b.recoveryPeriod": "string",
        "partThree.sectionB.lineNineteen.c": "object",
        "partThree.sectionB.lineNineteen.c.basis": "number",
        "partThree.sectionB.lineNineteen.c.convention": "string",
        "partThree.sectionB.lineNineteen.c.depreciation": "number",
        "partThree.sectionB.lineNineteen.c.method": "string",
        "partThree.sectionB.lineNineteen.c.monthYearPlaced": "string",
        "partThree.sectionB.lineNineteen.c.recoveryPeriod": "string",
        "partThree.sectionB.lineNineteen.d": "object",
        "partThree.sectionB.lineNineteen.d.basis": "number",
        "partThree.sectionB.lineNineteen.d.convention": "string",
        "partThree.sectionB.lineNineteen.d.depreciation": "number",
        "partThree.sectionB.lineNineteen.d.method": "string",
        "partThree.sectionB.lineNineteen.d.monthYearPlaced": "string",
        "partThree.sectionB.lineNineteen.d.recoveryPeriod": "string",
        "partThree.sectionB.lineNineteen.e": "object",
        "partThree.sectionB.lineNineteen.e.basis": "number",
        "partThree.sectionB.lineNineteen.e.convention": "string",
        "partThree.sectionB.lineNineteen.e.depreciation": "number",
        "partThree.sectionB.lineNineteen.e.method": "string",
        "partThree.sectionB.lineNineteen.e.monthYearPlaced": "string",
        "partThree.sectionB.lineNineteen.e.recoveryPeriod": "string",
        "partThree.sectionB.lineNineteen.f": "object",
        "partThree.sectionB.lineNineteen.f.basis": "number",
        "partThree.sectionB.lineNineteen.f.convention": "string",
        "partThree.sectionB.lineNineteen.f.depreciation": "number",
        "partThree.sectionB.lineNineteen.f.method": "string",
        "partThree.sectionB.lineNineteen.f.monthYearPlaced": "string",
        "partThree.sectionB.lineNineteen.f.recoveryPeriod": "string",
        "partThree.sectionB.lineNineteen.g": "object",
        "partThree.sectionB.lineNineteen.g.basis": "number",
        "partThree.sectionB.lineNineteen.g.convention": "string",
        "partThree.sectionB.lineNineteen.g.depreciation": "number",
        "partThree.sectionB.lineNineteen.g.method": "string",
        "partThree.sectionB.lineNineteen.g.monthYearPlaced": "string",
        "partThree.sectionB.lineNineteen.g.recoveryPeriod": "string",
        "partThree.sectionB.lineNineteen.h": "object",
        "partThree.sectionB.lineNineteen.h.basis": "number",
        "partThree.sectionB.lineNineteen.h.convention": "string",
        "partThree.sectionB.lineNineteen.h.depreciation": "number",
        "partThree.sectionB.lineNineteen.h.method": "string",
        "partThree.sectionB.lineNineteen.h.monthYearPlaced": "string",
        "partThree.sectionB.lineNineteen.h.recoveryPeriod": "string",
        "partThree.sectionB.lineNineteen.i": "object",
        "partThree.sectionB.lineNineteen.i.basis": "number",
        "partThree.sectionB.lineNineteen.i.convention": "string",
        "partThree.sectionB.lineNineteen.i.depreciation": "number",
        "partThree.sectionB.lineNineteen.i.method": "string",
        "partThree.sectionB.lineNineteen.i.monthYearPlaced": "string",
        "partThree.sectionB.lineNineteen.i.recoveryPeriod": "string",
        "partThree.sectionC": "object",
        "partThree.sectionC.lineTwenty": "array",
        "partThree.sectionC.lineTwenty[]": "object",
        "partThree.sectionC.lineTwenty[].basis": "number",
        "partThree.sectionC.lineTwenty[].classification": "string",
        "partThree.sectionC.lineTwenty[].convention": "string",
        "partThree.sectionC.lineTwenty[].depreciation": "number",
        "partThree.sectionC.lineTwenty[].method": "string",
        "partThree.sectionC.lineTwenty[].monthYearPlaced": "string",
        "partThree.sectionC.lineTwenty[].recoveryPeriod": "string",
        "partTwo": "object",
        "partTwo.lineFifteen": "number",
        "partTwo.lineFourteen": "number",
        "partTwo.lineSixteen": "number"
    },
    "Form4562PageTwoData": {
        "partFive": "object",
        "partFive.sectionA": "object",
        "partFive.sectionA.lineTwentyEight": "number",
        "partFive.sectionA.lineTwentyFive": "number",
        "partFive.sectionA.lineTwentyFour": "object",
        "partFive.sectionA.lineTwentyFour.a": "boolean",
        "partFive.sectionA.lineTwentyFour.b": "boolean",
        "partFive.sectionA.lineTwentyNine": "number",
        "partFive.sectionA.lineTwentySeven": "array",
        "partFive.sectionA.lineTwentySeven[]": "object",
        "partFive.sectionA.lineTwentySeven[].basisForDepreciation": "number",
        "partFive.sectionA.lineTwentySeven[].businessUsePercentage": "number",
        "partFive.sectionA.lineTwentySeven[].cost": "number",
        "partFive.sectionA.lineTwentySeven[].datePlaced": "string",
        "partFive.sectionA.lineTwentySeven[].depreciationDeduction": "number",
        "partFive.sectionA.lineTwentySeven[].methodConvention": "string",
        "partFive.sectionA.lineTwentySeven[].recoveryPeriod": "string",
        "partFive.sectionA.lineTwentySeven[].type": "string",
        "partFive.sectionA.lineTwentySix": "array",
        "partFive.sectionA.lineTwentySix[]": "object",
        "partFive.sectionA.lineTwentySix[].basisForDepreciation": "number",
        "partFive.sectionA.lineTwentySix[].businessUsePercentage": "number",
        "partFive.sectionA.lineTwentySix[].cost": "number",
        "partFive.sectionA.lineTwentySix[].datePlaced": "string",
        "partFive.sectionA.lineTwentySix[].depreciationDeduction": "number",
        "partFive.sectionA.lineTwentySix[].methodConvention": "string",
        "partFive.sectionA.lineTwentySix[].recoveryPeriod": "string",
        "partFive.sectionA.lineTwentySix[].section179Cost": "number",
        "partFive.sectionA.lineTwentySix[].type": "string",
        "partFive.sectionB": "object",
        "partFive.sectionB.vehicles": "array",
        "partFive.sectionB.vehicles[]": "object",
        "partFive.sectionB.vehicles[].lineThirty": "number",
        "partFive.sectionB.vehicles[].lineThirtyFive": "boolean",
        "partFive.sectionB.vehicles[].lineThirtyFour": "boolean",
        "partFive.sectionB.vehicles[].lineThirtyOne": "number",
        "partFive.sectionB.vehicles[].lineThirtySix": "boolean",
        "partFive.sectionB.vehicles[].lineThirtyThree": "number",
        "partFive.sectionB.vehicles[].lineThirtyTwo": "number",
        "partFive.sectionB.vehicles[].vehicleNumber": "number",
        "partFive.sectionC": "object",
        "partFive.sectionC.lineForty": "boolean",
        "partFive.sectionC.lineFortyOne": "boolean",
        "partFive.sectionC.lineThirtyEight": "boolean",
        "partFive.sectionC.lineThirtyNine": "boolean",
        "partFive.sectionC.lineThirtySeven": "boolean",
        "partSix": "object",
        "partSix.lineFortyFive": "number",
        "partSix.lineFortyFour": "number",
        "partSix.lineFortyThree": "number",
        "partSix.lineFortyTwo": "array",
        "partSix.lineFortyTwo[]": "object",
        "partSix.lineFortyTwo[].amortizableAmount": "number",
        "partSix.lineFortyTwo[].amortizationThisYear": "number",
        "partSix.lineFortyTwo[].codeSection": "string",
        "partSix.lineFortyTwo[].dateBegins": "string",
        "partSix.lineFortyTwo[].description": "string",
        "partSix.lineFortyTwo[].periodOrPercentage": "string"
    },
    "Form4684PageOneData": {
        "header": "object",
        "header.federallyDeclaredDisaster": "object",
        "header.federallyDeclaredDisaster.femaDeclarationNumber": "string",
        "header.federallyDeclaredDisaster.isDeclared": "boolean",
        "header.identifyingNumber": "string",
        "header.name": "string",
        "sectionA": "object",
        "sectionA.lineEighteen": "number",
        "sectionA.lineFifteen": "number",
        "sectionA.lineFourteen": "object",
        "sectionA.lineFourteen.excessAmount": "number",
        "sectionA.lineFourteen.hasExcessGain": "boolean",
        "sectionA.lineSeventeen": "number",
        "sectionA.lineSixteen": "number",
        "sectionA.lineThirteen": "number",
        "sectionA.lineTwelve": "number",
        "sectionA.properties": "array",
        "sectionA.properties[]": "object",
        "sectionB": "object",
        "sectionB.lineTwentyEight": "number",
        "sectionB.lineTwentyFive": "number",
        "sectionB.lineTwentyNine": "number",
        "sectionB.lineTwentySeven": "object",
        "sectionB.lineTwentySeven.hasNetGain": "boolean",
        "sectionB.lineTwentySeven.hasNetLoss": "boolean",
        "sectionB.lineTwentySeven.netAmount": "number",
        "sectionB.lineTwentySix": "number",
        "sectionB.properties": "array",
        "sectionB.properties[]": "object"
    },
    "Form4684PageTwoData": {
        "sectionBPartTwo": "object",
        "sectionBPartTwo.casualtyOrTheft": "object",
        "sectionBPartTwo.casualtyOrTheft.lineThirty": "object",
        "sectionBPartTwo.casualtyOrTheft.lineThirty.a": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirty.b_i": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirty.b_ii": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirty.c": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirtyEight": "object",
        "sectionBPartTwo.casualtyOrTheft.lineThirtyEight.a": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirtyEight.b": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirtyEight.c": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirtyFive": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirtyFour": "object",
        "sectionBPartTwo.casualtyOrTheft.lineThirtyFour.a": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirtyFour.b_i": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirtyFour.b_ii": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirtyFour.c": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirtyOne": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirtySeven": "object",
        "sectionBPartTwo.casualtyOrTheft.lineThirtySeven.isLessThanZero": "boolean",
        "sectionBPartTwo.casualtyOrTheft.lineThirtySeven.isZeroOrMore": "boolean",
        "sectionBPartTwo.casualtyOrTheft.lineThirtySix": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirtyThree": "number",
        "sectionBPartTwo.casualtyOrTheft.lineThirtyTwo": "number",
        "sectionC": "object",
        "sectionC.dateAcquired": "string",
        "sectionC.dateSold": "string",
        "sectionC.description": "string",
        "sectionD": "object",
        "sectionD.electionInfo": "object",
        "sectionD.electionInfo.cityOrCounty": "string",
        "sectionD.electionInfo.disasterDate": "string",
        "sectionD.electionInfo.femaDeclarationDate": "string",
        "sectionD.electionInfo.femaDeclarationNumber": "string",
        "sectionD.electionInfo.propertyAddress": "object",
        "sectionD.electionInfo.propertyAddress.city": "string",
        "sectionD.electionInfo.propertyAddress.state": "string",
        "sectionD.electionInfo.propertyAddress.street": "string",
        "sectionD.electionInfo.propertyAddress.zipCode": "string",
        "sectionD.electionInfo.propertyDescription": "string"
    },
    "Form8582PageOneData": {
        "header": "object",
        "header.identifyingNumber": "string",
        "header.name": "string",
        "partOne": "object",
        "partOne.lineOne": "object",
        "partOne.lineOne.a": "number",
        "partOne.lineOne.b": "number",
        "partOne.lineOne.c": "number",
        "partOne.lineOne.d": "number",
        "partOne.lineThree": "number",
        "partOne.lineTwo": "object",
        "partOne.lineTwo.a": "number",
        "partOne.lineTwo.b": "number",
        "partOne.lineTwo.c": "number",
        "partOne.lineTwo.d": "number",
        "partThree": "object",
        "partThree.lineFifteen": "number",
        "partThree.lineFourteen": "number",
        "partThree.lineThirteen": "object",
        "partThree.lineThirteen.a": "number",
        "partThree.lineThirteen.b": "number",
        "partThree.lineTwelve": "number",
        "partTwo": "object",
        "partTwo.lineEight": "number",
        "partTwo.lineEleven": "number",
        "partTwo.lineFive": "number",
        "partTwo.lineFour": "number",
        "partTwo.lineNine": "number",
        "partTwo.lineSeven": "number",
        "partTwo.lineSix": "number",
        "partTwo.lineTen": "number"
    },
    "Form8582PageThreeData": {
        "partSix": "object",
        "partSix.worksheetFive": "object",
        "partSix.worksheetFive.lineFiveA": "number",
        "partSix.worksheetFive.lineFiveB": "number",
        "partSix.worksheetFive.lineFiveC": "number",
        "partSix.worksheetFour": "object",
        "partSix.worksheetFour.lineFourA": "number",
        "partSix.worksheetFour.lineFourB": "number",
        "partSix.worksheetOne": "object",
        "partSix.worksheetOne.lineOneA": "number",
        "partSix.worksheetOne.lineOneB": "number",
        "partSix.worksheetOne.lineOneC": "number",
        "partSix.worksheetOne.lineOneD": "number",
        "partSix.worksheetOne.lineOneE": "number",
        "partSix.worksheetSeven": "object",
        "partSix.worksheetSeven.lineSevenA": "number",
        "partSix.worksheetSeven.lineSevenB": "number",
        "partSix.worksheetSix": "object",
        "partSix.worksheetSix.lineSixA": "number",
        "partSix.worksheetSix.lineSixB": "number",
        "partSix.worksheetSix.lineSixC": "number",
        "partSix.worksheetThree": "object",
        "partSix.worksheetThree.lineThreeA": "number",
        "partSix.worksheetThree.lineThreeB": "number",
        "partSix.worksheetThree.lineThreeC": "number",
        "partSix.worksheetTwo": "object",
        "partSix.worksheetTwo.lineTwoA": "number",
        "partSix.worksheetTwo.lineTwoB": "number",
        "partSix.worksheetTwo.lineTwoC": "number"
    },
    "Form8582PageTwoData": {
        "partFive": "object",
        "partFive.allOtherPassiveActivities": "array",
        "partFive.allOtherPassiveActivities[]": "object",
        "partFive.totals": "object",
        "partFive.totals.netIncome": "number",
        "partFive.totals.netLoss": "number",
        "partFive.totals.priorYearUnallowedLoss": "number",
        "partFour": "object",
        "partFour.rentalRealEstateWithActiveParticipation": "array",
        "partFour.rentalRealEstateWithActiveParticipation[]": "object",
        "partFour.totals": "object",
        "partFour.totals.netIncome": "number",
        "partFour.totals.netLoss": "number",
        "partFour.totals.priorYearUnallowedLoss": "number"
    },
    "Form8825PageOneData": {
        "header": "object",
        "header.ein": "string",
        "header.name": "string",
        "rentalProperties": "array",
        "rentalProperties[]": "object",
        "totals": "object",
        "totals.lineEight": "number",
        "totals.lineEleven": "number",
        "totals.lineFifteen": "number",
        "totals.lineFive": "number",
        "totals.lineFour": "number",
        "totals.lineFourteen": "number",
        "totals.lineNine": "number",
        "totals.lineSeven": "number",
        "totals.lineSeventeen": "number",
        "totals.lineSix": "number",
        "totals.lineSixteen": "number",
        "totals.lineTen": "number",
        "totals.lineThirteen": "number",
        "totals.lineThree": "number",
        "totals.lineTwelve": "number",
        "totals.lineTwo": "number"
    },
    "Form8949Data": {
        "header": "object",
        "header.name": "string",
        "header.socialSecurityNumber": "string",
        "partOne": "object",
        "partOne.checkBox": "literal",
        "partOne.totals": "object",
        "partOne.totals.adjustments": "number",
        "partOne.totals.costBasis": "number",
        "partOne.totals.gainOrLoss": "number",
        "partOne.totals.proceeds": "number",
        "partOne.transactions": "array",
        "partOne.transactions[]": "object",
        "partTwo": "object",
        "partTwo.checkBox": "literal",
        "partTwo.totals": "object",
        "partTwo.totals.adjustments": "number",
        "partTwo.totals.costBasis": "number",
        "partTwo.totals.gainOrLoss": "number",
        "partTwo.totals.proceeds": "number",
        "partTwo.transactions": "array",
        "partTwo.transactions[]": "object"
    },
    "Form8949ExtractedData": {
        "data": "object",
        "page": "number",
        "taxYear": "number"
    },
    "FormW2PageOneData": {
        "box1": "number",
        "box10": "number",
        "box11": "number",
        "box12": "object",
        "box12.codes": "array",
        "box13": "object",
        "box13.retirementPlan": "boolean",
        "box13.statutoryEmployee": "boolean",
        "box13.thirdPartySickPay": "boolean",
        "box14": "array",
        "box2": "number",
        "box3": "number",
        "box4": "number",
        "box5": "number",
        "box6": "number",
        "box7": "number",
        "box8": "number",
        "box9": "number",
        "controlNumber": "string",
        "employeeInfo": "object",
        "employeeInfo.address": "object",
        "employeeInfo.address.apartment": "string",
        "employeeInfo.address.city": "string",
        "employeeInfo.address.state": "string",
        "employeeInfo.address.street": "string",
        "employeeInfo.address.zipCode": "string",
        "employeeInfo.firstName": "string",
        "employeeInfo.lastName": "string",
        "employeeInfo.middleInitial": "string",
        "employeeInfo.ssn": "string",
        "employeeInfo.suffix": "string",
        "employerInfo": "object",
        "employerInfo.address": "object",
        "employerInfo.address.city": "string",
        "employerInfo.address.state": "string",
        "employerInfo.address.street": "string",
        "employerInfo.address.suite": "string",
        "employerInfo.address.zipCode": "string",
        "employerInfo.ein": "string",
        "employerInfo.name": "string",
        "stateAndLocal": "object",
        "stateAndLocal.box15": "string",
        "stateAndLocal.box16": "number",
        "stateAndLocal.box17": "number",
        "stateAndLocal.box18": "number",
        "stateAndLocal.box19": "number",
        "stateAndLocal.box20": "string"
    },
    "IncomeReconciliationItem": {
        "columnA": "number",
        "columnB": "number",
        "columnC": "number",
        "columnD": "number",
        "description": "string",
        "lineNumber": "string"
    },
    "InterestSource": {
        "adjustmentAmount": "number",
        "adjustmentDescription": "string",
        "amount": "number",
        "isAccruedInterest": "boolean",
        "isNomineeDistribution": "boolean",
        "isPrivateActivityBond": "boolean",
        "isTaxExempt": "boolean",
        "payerName": "string"
    },
    "LongTermTransaction": {
        "adjustmentAmount": "number",
        "adjustmentCode": "string",
        "costBasis": "number",
        "dateAcquired": "string",
        "dateSold": "string",
        "description": "string",
        "gainOrLoss": "number",
        "proceeds": "number"
    },
    "OfficerCompensation": {
        "columnA": "string",
        "columnB": "string",
        "columnC": "number",
        "columnD": "object",
        "columnD.percentOfPreferredStock": "number",
        "columnD.percentOfStock": "number",
        "columnE": "number",
        "rowNumber": "number"
    },
    "OtherDeductionItem": {
        "amount": "number",
        "code": "string",
        "description": "string"
    },
    "OtherIncomeItem": {
        "amount": "number",
        "code": "string",
        "description": "string"
    },
    "OtherInformationItem": {
        "amount": "number",
        "code": "string",
        "description": "string",
        "percentage": "number"
    },
    "PassiveActivity": {
        "activityName": "string",
        "netIncome": "number",
        "netLoss": "number",
        "priorYearUnallowedLoss": "number"
    },
    "PassthroughEntity": {
        "atRiskBasis": "boolean",
        "checkIfForeignPartnership": "boolean",
        "ein": "string",
        "name": "string",
        "nonpassiveIncome": "number",
        "nonpassiveLoss": "number",
        "passiveIncome": "number",
        "passiveLoss": "number",
        "section179Deduction": "number"
    },
    "PersonalCasualtyProperty": {
        "description": "string",
        "lineEight": "number",
        "lineEleven": "number",
        "lineFive": "number",
        "lineFour": "number",
        "lineNine": "number",
        "lineOne": "number",
        "lineSeven": "number",
        "lineSix": "number",
        "lineTen": "number",
        "lineThree": "number",
        "lineTwo": "number",
        "propertyLetter": "literal",
        "zipCode": "string"
    },
    "REMIC": {
        "ein": "string",
        "excessInclusion": "number",
        "incomeOnLine38": "number",
        "name": "string",
        "taxableIncomeOrNetLoss": "number"
    },
    "RentalActivity": {
        "activityName": "string",
        "netIncome": "number",
        "netLoss": "number",
        "priorYearUnallowedLoss": "number"
    },
    "RentalProperty": {
        "expenses": "object",
        "expenses.lineEight": "number",
        "expenses.lineEleven": "number",
        "expenses.lineFifteen": "number",
        "expenses.lineFive": "number",
        "expenses.lineFour": "number",
        "expenses.lineFourteen": "number",
        "expenses.lineNine": "number",
        "expenses.lineSeven": "number",
        "expenses.lineSix": "number",
        "expenses.lineSixteen": "number",
        "expenses.lineTen": "number",
        "expenses.lineThirteen": "number",
        "expenses.lineThree": "number",
        "expenses.lineTwelve": "number",
        "lineSeventeen": "number",
        "propertyDetails": "object",
        "propertyDetails.lineOne": "object",
        "propertyDetails.lineOne.location": "string",
        "propertyDetails.lineOne.type": "string",
        "propertyDetails.lineTwo": "number",
        "propertyLetter": "literal"
    },
    "RentalPropertyInfo": {
        "address": "object",
        "address.city": "string",
        "address.foreignCountry": "string",
        "address.foreignPostalCode": "string",
        "address.foreignProvince": "string",
        "address.state": "string",
        "address.street": "string",
        "address.zipCode": "string",
        "fairRentalDays": "number",
        "personalUseDays": "number",
        "propertyType": "string",
        "qjv": "boolean"
    },
    "S_CorpAMTItem": {
        "amount": "number",
        "code": "string",
        "description": "string"
    },
    "S_CorpBalanceSheetData": {
        "assets": "object",
        "assets.lineEight": "number",
        "assets.lineEleven": "object",
        "assets.lineEleven.a": "number",
        "assets.lineEleven.b": "number",
        "assets.lineFifteen": "number",
        "assets.lineFive": "number",
        "assets.lineFour": "number",
        "assets.lineFourteen": "number",
        "assets.lineNine": "number",
        "assets.lineOne": "number",
        "assets.lineSeven": "number",
        "assets.lineSix": "number",
        "assets.lineTen": "object",
        "assets.lineTen.a": "number",
        "assets.lineTen.b": "number",
        "assets.lineThirteen": "object",
        "assets.lineThirteen.a": "number",
        "assets.lineThirteen.b": "number",
        "assets.lineThree": "number",
        "assets.lineTwelve": "number",
        "assets.lineTwo": "object",
        "assets.lineTwo.a": "number",
        "assets.lineTwo.b": "number",
        "liabilitiesAndShareholdersEquity": "object",
        "liabilitiesAndShareholdersEquity.lineEighteen": "number",
        "liabilitiesAndShareholdersEquity.lineNineteen": "number",
        "liabilitiesAndShareholdersEquity.lineSeventeen": "number",
        "liabilitiesAndShareholdersEquity.lineSixteen": "number",
        "liabilitiesAndShareholdersEquity.lineTwenty": "number",
        "liabilitiesAndShareholdersEquity.lineTwentyFive": "number",
        "liabilitiesAndShareholdersEquity.lineTwentyFour": "number",
        "liabilitiesAndShareholdersEquity.lineTwentyOne": "number",
        "liabilitiesAndShareholdersEquity.lineTwentySeven": "number",
        "liabilitiesAndShareholdersEquity.lineTwentySix": "number",
        "liabilitiesAndShareholdersEquity.lineTwentyThree": "number",
        "liabilitiesAndShareholdersEquity.lineTwentyTwo": "number"
    },
    "S_CorpCreditItem": {
        "amount": "number",
        "code": "string",
        "description": "string"
    },
    "S_CorpExpenseReconciliationItem": {
        "columnA": "number",
        "columnB": "number",
        "columnC": "number",
        "columnD": "number",
        "description": "string",
        "lineNumber": "string"
    },
    "S_CorpForeignTransactionItem": {
        "amount": "number",
        "code": "string",
        "countryCode": "string",
        "description": "string"
    },
    "S_CorpIncomeReconciliationItem": {
        "columnA": "number",
        "columnB": "number",
        "columnC": "number",
        "columnD": "number",
        "description": "string",
        "lineNumber": "string"
    },
    "S_CorpOtherDeductionItem": {
        "amount": "number",
        "code": "string",
        "description": "string"
    },
    "S_CorpOtherIncomeItem": {
        "amount": "number",
        "code": "string",
        "description": "string"
    },
    "S_CorpOtherInformationItem": {
        "amount": "number",
        "code": "string",
        "description": "string",
        "percentage": "number"
    },
    "Schedule1PageOneData": {
        "header": "object",
        "header.form1099kAdjustment": "number",
        "header.name": "string",
        "header.socialSecurityNumber": "string",
        "partOne": "object",
        "partOne.lineEight": "object",
        "partOne.lineEight.a": "number",
        "partOne.lineEight.b": "number",
        "partOne.lineEight.c": "number",
        "partOne.lineEight.d": "number",
        "partOne.lineEight.e": "number",
        "partOne.lineEight.f": "number",
        "partOne.lineEight.g": "number",
        "partOne.lineEight.h": "number",
        "partOne.lineEight.i": "number",
        "partOne.lineEight.j": "number",
        "partOne.lineEight.k": "number",
        "partOne.lineEight.l": "number",
        "partOne.lineEight.m": "number",
        "partOne.lineEight.n": "number",
        "partOne.lineEight.o": "number",
        "partOne.lineEight.p": "number",
        "partOne.lineEight.q": "number",
        "partOne.lineEight.r": "number",
        "partOne.lineEight.s": "number",
        "partOne.lineEight.t": "number",
        "partOne.lineEight.u": "number",
        "partOne.lineEight.v": "number",
        "partOne.lineEight.w": "number",
        "partOne.lineEight.z": "object",
        "partOne.lineEight.z.amount": "number",
        "partOne.lineEight.z.description": "string",
        "partOne.lineFive": "number",
        "partOne.lineFour": "number",
        "partOne.lineNine": "null",
        "partOne.lineOne": "number",
        "partOne.lineSeven": "number",
        "partOne.lineSix": "number",
        "partOne.lineTen": "number",
        "partOne.lineThree": "number",
        "partOne.lineTwo": "object",
        "partOne.lineTwo.a": "number",
        "partOne.lineTwo.b": "string"
    },
    "Schedule1PageTwoData": {
        "partTwo": "object",
        "partTwo.lineEighteen": "number",
        "partTwo.lineEleven": "number",
        "partTwo.lineFifteen": "number",
        "partTwo.lineFourteen": "number",
        "partTwo.lineNineteen": "object",
        "partTwo.lineNineteen.a": "number",
        "partTwo.lineNineteen.b": "string",
        "partTwo.lineNineteen.c": "string",
        "partTwo.lineSeventeen": "number",
        "partTwo.lineSixteen": "number",
        "partTwo.lineThirteen": "number",
        "partTwo.lineTwelve": "number",
        "partTwo.lineTwenty": "number",
        "partTwo.lineTwentyFive": "number",
        "partTwo.lineTwentyFour": "object",
        "partTwo.lineTwentyFour.a": "number",
        "partTwo.lineTwentyFour.b": "number",
        "partTwo.lineTwentyFour.c": "number",
        "partTwo.lineTwentyFour.d": "number",
        "partTwo.lineTwentyFour.e": "number",
        "partTwo.lineTwentyFour.f": "number",
        "partTwo.lineTwentyFour.g": "number",
        "partTwo.lineTwentyFour.h": "number",
        "partTwo.lineTwentyFour.i": "number",
        "partTwo.lineTwentyFour.j": "number",
        "partTwo.lineTwentyFour.k": "number",
        "partTwo.lineTwentyFour.z": "object",
        "partTwo.lineTwentyFour.z.amount": "number",
        "partTwo.lineTwentyFour.z.description": "string",
        "partTwo.lineTwentyOne": "number",
        "partTwo.lineTwentySix": "number",
        "partTwo.lineTwentyThree": "number",
        "partTwo.lineTwentyTwo": "null"
    },
    "ScheduleBData": {
        "header": "object",
        "header.name": "string",
        "header.socialSecurityNumber": "string",
        "partOne": "object",
        "partOne.interestSources": "array",
        "partOne.interestSources[]": "object",
        "partOne.lineFour": "number",
        "partOne.lineOne": "number",
        "partOne.lineThree": "number",
        "partOne.lineTwo": "number",
        "partThree": "object",
        "partThree.lineEight": "object",
        "partThree.lineEight.hadForeignTrust": "boolean",
        "partThree.lineEight.requiresForm3520": "boolean",
        "partThree.lineSevenA": "object",
        "partThree.lineSevenA.hadForeignAccount": "boolean",
        "partThree.lineSevenB": "object",
        "partThree.lineSevenB.foreignCountries": "array",
        "partThree.lineSevenB.foreignCountries[]": "string",
        "partTwo": "object",
        "partTwo.dividendSources": "array",
        "partTwo.dividendSources[]": "object",
        "partTwo.lineFive": "number",
        "partTwo.lineSix": "number"
    },
    "ScheduleCPageOneData": {
        "header": "object",
        "header.accountingMethod": "string",
        "header.businessAddress": "string",
        "header.businessLocale": "object",
        "header.businessLocale.city": "string",
        "header.businessLocale.state": "string",
        "header.businessLocale.zipcode": "string",
        "header.businessName": "string",
        "header.businessStarted": "boolean",
        "header.ein": "string",
        "header.filed1099": "boolean",
        "header.materialParticipation": "boolean",
        "header.naicsCode": "string",
        "header.nameOfProprietor": "string",
        "header.needs1099": "boolean",
        "header.principalBusinessOrProfession": "string",
        "header.socialSecurityNumber": "string",
        "partOne": "object",
        "partOne.lineFive": "number",
        "partOne.lineFour": "number",
        "partOne.lineOne": "number",
        "partOne.lineSeven": "number",
        "partOne.lineSix": "number",
        "partOne.lineThree": "number",
        "partOne.lineTwo": "number",
        "partTwo": "object",
        "partTwo.lineEight": "number",
        "partTwo.lineEighteen": "number",
        "partTwo.lineEleven": "number",
        "partTwo.lineFifteen": "number",
        "partTwo.lineFourteen": "number",
        "partTwo.lineNine": "number",
        "partTwo.lineNineteen": "number",
        "partTwo.lineSeventeen": "number",
        "partTwo.lineSixteen": "object",
        "partTwo.lineSixteen.a": "number",
        "partTwo.lineSixteen.b": "number",
        "partTwo.lineTen": "number",
        "partTwo.lineThirteen": "number",
        "partTwo.lineThirty": "object",
        "partTwo.lineThirty.simplifiedMethod": "boolean",
        "partTwo.lineThirty.value": "number",
        "partTwo.lineThirtyOne": "number",
        "partTwo.lineThirtyTwo": "object",
        "partTwo.lineThirtyTwo.allInvestmentAtRisk": "boolean",
        "partTwo.lineThirtyTwo.someInvestmentNotAtRisk": "boolean",
        "partTwo.lineTwelve": "number",
        "partTwo.lineTwenty": "object",
        "partTwo.lineTwenty.a": "number",
        "partTwo.lineTwenty.b": "number",
        "partTwo.lineTwentyEight": "number",
        "partTwo.lineTwentyFive": "number",
        "partTwo.lineTwentyFour": "object",
        "partTwo.lineTwentyFour.a": "number",
        "partTwo.lineTwentyFour.b": "number",
        "partTwo.lineTwentyNine": "number",
        "partTwo.lineTwentyOne": "number",
        "partTwo.lineTwentySeven": "object",
        "partTwo.lineTwentySeven.a": "number",
        "partTwo.lineTwentySeven.b": "number",
        "partTwo.lineTwentySix": "number",
        "partTwo.lineTwentyThree": "number",
        "partTwo.lineTwentyTwo": "number"
    },
    "ScheduleCPageTwoData": {
        "partFive": "object",
        "partFive.amortization": "number",
        "partFive.casualtyLoss": "number",
        "partFive.lineFortyEight": "number",
        "partFive.otherExpenses": "array",
        "partFive.otherExpenses[]": "object",
        "partFive.otherExpenses[].amount": "number",
        "partFive.otherExpenses[].description": "string",
        "partFour": "object",
        "partFour.lineFortyFive": "object",
        "partFour.lineFortyFive.no": "boolean",
        "partFour.lineFortyFive.yes": "boolean",
        "partFour.lineFortyFour": "object",
        "partFour.lineFortyFour.a": "number",
        "partFour.lineFortyFour.b": "number",
        "partFour.lineFortyFour.c": "number",
        "partFour.lineFortySeven": "object",
        "partFour.lineFortySeven.a": "object",
        "partFour.lineFortySeven.a.no": "boolean",
        "partFour.lineFortySeven.a.yes": "boolean",
        "partFour.lineFortySeven.b": "object",
        "partFour.lineFortySeven.b.no": "boolean",
        "partFour.lineFortySeven.b.yes": "boolean",
        "partFour.lineFortySix": "object",
        "partFour.lineFortySix.no": "boolean",
        "partFour.lineFortySix.yes": "boolean",
        "partFour.lineFortyThree": "object",
        "partFour.lineFortyThree.date": "string",
        "partThree": "object",
        "partThree.lineForty": "number",
        "partThree.lineFortyOne": "number",
        "partThree.lineFortyTwo": "number",
        "partThree.lineThirtyEight": "number",
        "partThree.lineThirtyFive": "number",
        "partThree.lineThirtyFour": "object",
        "partThree.lineThirtyFour.explanation": "string",
        "partThree.lineThirtyFour.no": "boolean",
        "partThree.lineThirtyFour.yes": "boolean",
        "partThree.lineThirtyNine": "number",
        "partThree.lineThirtySeven": "number",
        "partThree.lineThirtySix": "number",
        "partThree.lineThirtyThree": "object",
        "partThree.lineThirtyThree.cost": "boolean",
        "partThree.lineThirtyThree.lowerOfCostOrMarket": "boolean",
        "partThree.lineThirtyThree.other": "boolean",
        "partThree.lineThirtyThree.otherMethod": "string"
    },
    "ScheduleDPageOneData": {
        "header": "object",
        "header.name": "string",
        "header.socialSecurityNumber": "string",
        "partOne": "object",
        "partOne.lineFive": "number",
        "partOne.lineFour": "number",
        "partOne.lineOne": "object",
        "partOne.lineOne.a": "number",
        "partOne.lineOne.b": "number",
        "partOne.lineOne.c": "number",
        "partOne.lineSeven": "number",
        "partOne.lineSix": "number",
        "partOne.lineThree": "number",
        "partOne.lineTwo": "number",
        "partTwo": "object",
        "partTwo.lineEight": "object",
        "partTwo.lineEight.a": "number",
        "partTwo.lineEight.b": "number",
        "partTwo.lineEight.c": "number",
        "partTwo.lineEleven": "number",
        "partTwo.lineFifteen": "number",
        "partTwo.lineFourteen": "number",
        "partTwo.lineNine": "number",
        "partTwo.lineTen": "number",
        "partTwo.lineThirteen": "number",
        "partTwo.lineTwelve": "number",
        "qualifiedOpportunityFund": "boolean"
    },
    "ScheduleDPageTwoData": {
        "partThree": "object",
        "partThree.lineEighteen": "object",
        "partThree.lineEighteen.qualifiedDividendsAmount": "number",
        "partThree.lineNineteen": "number",
        "partThree.lineSeventeen": "object",
        "partThree.lineSeventeen.bothGains": "boolean",
        "partThree.lineSixteen": "number",
        "partThree.lineTwenty": "object",
        "partThree.lineTwenty.hasQualifiedSmallBusinessStock": "boolean",
        "partThree.lineTwentyOne": "number",
        "partThree.lineTwentyTwo": "boolean"
    },
    "ScheduleEPageOneData": {
        "header": "object",
        "header.name": "string",
        "header.socialSecurityNumber": "string",
        "partOne": "object",
        "partOne.incomeAndExpenses": "object",
        "partOne.incomeAndExpenses.expenses": "object",
        "partOne.incomeAndExpenses.expenses.lineEight": "object",
        "partOne.incomeAndExpenses.expenses.lineEight.A": "number",
        "partOne.incomeAndExpenses.expenses.lineEight.B": "number",
        "partOne.incomeAndExpenses.expenses.lineEight.C": "number",
        "partOne.incomeAndExpenses.expenses.lineEight.total": "number",
        "partOne.incomeAndExpenses.expenses.lineEighteen": "object",
        "partOne.incomeAndExpenses.expenses.lineEighteen.A": "number",
        "partOne.incomeAndExpenses.expenses.lineEighteen.B": "number",
        "partOne.incomeAndExpenses.expenses.lineEighteen.C": "number",
        "partOne.incomeAndExpenses.expenses.lineEighteen.total": "number",
        "partOne.incomeAndExpenses.expenses.lineEleven": "object",
        "partOne.incomeAndExpenses.expenses.lineEleven.A": "number",
        "partOne.incomeAndExpenses.expenses.lineEleven.B": "number",
        "partOne.incomeAndExpenses.expenses.lineEleven.C": "number",
        "partOne.incomeAndExpenses.expenses.lineEleven.total": "number",
        "partOne.incomeAndExpenses.expenses.lineFifteen": "object",
        "partOne.incomeAndExpenses.expenses.lineFifteen.A": "number",
        "partOne.incomeAndExpenses.expenses.lineFifteen.B": "number",
        "partOne.incomeAndExpenses.expenses.lineFifteen.C": "number",
        "partOne.incomeAndExpenses.expenses.lineFifteen.total": "number",
        "partOne.incomeAndExpenses.expenses.lineFive": "object",
        "partOne.incomeAndExpenses.expenses.lineFive.A": "number",
        "partOne.incomeAndExpenses.expenses.lineFive.B": "number",
        "partOne.incomeAndExpenses.expenses.lineFive.C": "number",
        "partOne.incomeAndExpenses.expenses.lineFive.total": "number",
        "partOne.incomeAndExpenses.expenses.lineFourteen": "object",
        "partOne.incomeAndExpenses.expenses.lineFourteen.A": "number",
        "partOne.incomeAndExpenses.expenses.lineFourteen.B": "number",
        "partOne.incomeAndExpenses.expenses.lineFourteen.C": "number",
        "partOne.incomeAndExpenses.expenses.lineFourteen.total": "number",
        "partOne.incomeAndExpenses.expenses.lineNine": "object",
        "partOne.incomeAndExpenses.expenses.lineNine.A": "number",
        "partOne.incomeAndExpenses.expenses.lineNine.B": "number",
        "partOne.incomeAndExpenses.expenses.lineNine.C": "number",
        "partOne.incomeAndExpenses.expenses.lineNine.total": "number",
        "partOne.incomeAndExpenses.expenses.lineNineteen": "object",
        "partOne.incomeAndExpenses.expenses.lineNineteen.A": "number",
        "partOne.incomeAndExpenses.expenses.lineNineteen.B": "number",
        "partOne.incomeAndExpenses.expenses.lineNineteen.C": "number",
        "partOne.incomeAndExpenses.expenses.lineNineteen.description": "string",
        "partOne.incomeAndExpenses.expenses.lineNineteen.total": "number",
        "partOne.incomeAndExpenses.expenses.lineSeven": "object",
        "partOne.incomeAndExpenses.expenses.lineSeven.A": "number",
        "partOne.incomeAndExpenses.expenses.lineSeven.B": "number",
        "partOne.incomeAndExpenses.expenses.lineSeven.C": "number",
        "partOne.incomeAndExpenses.expenses.lineSeven.total": "number",
        "partOne.incomeAndExpenses.expenses.lineSeventeen": "object",
        "partOne.incomeAndExpenses.expenses.lineSeventeen.A": "number",
        "partOne.incomeAndExpenses.expenses.lineSeventeen.B": "number",
        "partOne.incomeAndExpenses.expenses.lineSeventeen.C": "number",
        "partOne.incomeAndExpenses.expenses.lineSeventeen.total": "number",
        "partOne.incomeAndExpenses.expenses.lineSix": "object",
        "partOne.incomeAndExpenses.expenses.lineSix.A": "number",
        "partOne.incomeAndExpenses.expenses.lineSix.B": "number",
        "partOne.incomeAndExpenses.expenses.lineSix.C": "number",
        "partOne.incomeAndExpenses.expenses.lineSix.total": "number",
        "partOne.incomeAndExpenses.expenses.lineSixteen": "object",
        "partOne.incomeAndExpenses.expenses.lineSixteen.A": "number",
        "partOne.incomeAndExpenses.expenses.lineSixteen.B": "number",
        "partOne.incomeAndExpenses.expenses.lineSixteen.C": "number",
        "partOne.incomeAndExpenses.expenses.lineSixteen.total": "number",
        "partOne.incomeAndExpenses.expenses.lineTen": "object",
        "partOne.incomeAndExpenses.expenses.lineTen.A": "number",
        "partOne.incomeAndExpenses.expenses.lineTen.B": "number",
        "partOne.incomeAndExpenses.expenses.lineTen.C": "number",
        "partOne.incomeAndExpenses.expenses.lineTen.total": "number",
        "partOne.incomeAndExpenses.expenses.lineThirteen": "object",
        "partOne.incomeAndExpenses.expenses.lineThirteen.A": "number",
        "partOne.incomeAndExpenses.expenses.lineThirteen.B": "number",
        "partOne.incomeAndExpenses.expenses.lineThirteen.C": "number",
        "partOne.incomeAndExpenses.expenses.lineThirteen.total": "number",
        "partOne.incomeAndExpenses.expenses.lineTwelve": "object",
        "partOne.incomeAndExpenses.expenses.lineTwelve.A": "number",
        "partOne.incomeAndExpenses.expenses.lineTwelve.B": "number",
        "partOne.incomeAndExpenses.expenses.lineTwelve.C": "number",
        "partOne.incomeAndExpenses.expenses.lineTwelve.total": "number",
        "partOne.incomeAndExpenses.lineFour": "object",
        "partOne.incomeAndExpenses.lineFour.A": "number",
        "partOne.incomeAndExpenses.lineFour.B": "number",
        "partOne.incomeAndExpenses.lineFour.C": "number",
        "partOne.incomeAndExpenses.lineFour.total": "number",
        "partOne.incomeAndExpenses.lineThree": "object",
        "partOne.incomeAndExpenses.lineThree.A": "number",
        "partOne.incomeAndExpenses.lineThree.B": "number",
        "partOne.incomeAndExpenses.lineThree.C": "number",
        "partOne.incomeAndExpenses.lineThree.total": "number",
        "partOne.incomeAndExpenses.lineTwenty": "object",
        "partOne.incomeAndExpenses.lineTwenty.A": "number",
        "partOne.incomeAndExpenses.lineTwenty.B": "number",
        "partOne.incomeAndExpenses.lineTwenty.C": "number",
        "partOne.incomeAndExpenses.lineTwenty.total": "number",
        "partOne.incomeAndExpenses.lineTwentyOne": "object",
        "partOne.incomeAndExpenses.lineTwentyOne.A": "number",
        "partOne.incomeAndExpenses.lineTwentyOne.B": "number",
        "partOne.incomeAndExpenses.lineTwentyOne.C": "number",
        "partOne.incomeAndExpenses.lineTwentyOne.total": "number",
        "partOne.incomeAndExpenses.lineTwentyTwo": "object",
        "partOne.incomeAndExpenses.lineTwentyTwo.A": "number",
        "partOne.incomeAndExpenses.lineTwentyTwo.B": "number",
        "partOne.incomeAndExpenses.lineTwentyTwo.C": "number",
        "partOne.incomeAndExpenses.lineTwentyTwo.total": "number",
        "partOne.lineTwentyFive": "number",
        "partOne.lineTwentyFour": "number",
        "partOne.lineTwentySix": "number",
        "partOne.lineTwentyThree": "object",
        "partOne.lineTwentyThree.a": "number",
        "partOne.lineTwentyThree.b": "number",
        "partOne.lineTwentyThree.c": "number",
        "partOne.lineTwentyThree.d": "number",
        "partOne.lineTwentyThree.e": "number",
        "partOne.physicalProperties": "object",
        "partOne.physicalProperties.A": "object",
        "partOne.physicalProperties.B": "object",
        "partOne.physicalProperties.C": "object",
        "partOne.qjvElection": "boolean"
    },
    "ScheduleEPageTwoData": {
        "partFive": "object",
        "partFive.lineFortyOne": "number",
        "partFive.lineFortyTwo": "object",
        "partFive.lineFortyTwo.enterOnSchedule1": "boolean",
        "partFive.lineFortyTwo.reconciliationOfFarmingAndFishing": "number",
        "partFour": "object",
        "partFour.lineForty": "number",
        "partFour.lineThirtyEight": "number",
        "partFour.lineThirtyNine": "object",
        "partFour.lineThirtyNine.netIncome": "number",
        "partFour.lineThirtyNine.netLoss": "number",
        "partFour.remics": "array",
        "partFour.remics[]": "object",
        "partThree": "object",
        "partThree.estatesAndTrusts": "array",
        "partThree.estatesAndTrusts[]": "object",
        "partThree.lineThirtyFive": "number",
        "partThree.lineThirtyFour": "number",
        "partThree.lineThirtySeven": "number",
        "partThree.lineThirtySix": "number",
        "partThree.lineThirtyThree": "object",
        "partThree.lineThirtyThree.a": "number",
        "partThree.lineThirtyThree.b": "number",
        "partThree.lineThirtyThree.c": "number",
        "partThree.lineThirtyThree.d": "number",
        "partTwo": "object",
        "partTwo.lineThirty": "number",
        "partTwo.lineThirtyOne": "number",
        "partTwo.lineThirtyTwo": "number",
        "partTwo.lineTwentyNine": "object",
        "partTwo.lineTwentyNine.a": "number",
        "partTwo.lineTwentyNine.b": "number",
        "partTwo.lineTwentyNine.c": "number",
        "partTwo.lineTwentyNine.d": "number",
        "partTwo.nonpassiveIncomeAndLoss": "array",
        "partTwo.nonpassiveIncomeAndLoss[]": "object",
        "partTwo.passiveIncomeAndLoss": "array",
        "partTwo.passiveIncomeAndLoss[]": "object"
    },
    "ScheduleFPageOneData": {
        "header": "object",
        "header.accountingMethod": "literal",
        "header.investmentAtRisk": "literal",
        "header.materialParticipation": "boolean",
        "header.naicsCode": "string",
        "header.name": "string",
        "header.principalProduct": "string",
        "header.socialSecurityNumber": "string",
        "partOne": "object",
        "partOne.lineEight": "number",
        "partOne.lineFive": "object",
        "partOne.lineFive.a": "number",
        "partOne.lineFive.b": "number",
        "partOne.lineFour": "object",
        "partOne.lineFour.a": "number",
        "partOne.lineFour.b": "number",
        "partOne.lineNine": "number",
        "partOne.lineOne": "object",
        "partOne.lineOne.a": "number",
        "partOne.lineOne.b": "number",
        "partOne.lineOne.c": "number",
        "partOne.lineSeven": "number",
        "partOne.lineSix": "number",
        "partOne.lineThree": "object",
        "partOne.lineThree.a": "number",
        "partOne.lineThree.b": "number",
        "partOne.lineTwo": "number",
        "partTwo": "object",
        "partTwo.lineEighteen": "number",
        "partTwo.lineEleven": "number",
        "partTwo.lineFifteen": "number",
        "partTwo.lineFourteen": "number",
        "partTwo.lineNineteen": "number",
        "partTwo.lineSeventeen": "number",
        "partTwo.lineSixteen": "number",
        "partTwo.lineTen": "number",
        "partTwo.lineThirteen": "number",
        "partTwo.lineThirty": "number",
        "partTwo.lineThirtyFive": "object",
        "partTwo.lineThirtyFive.allInvestmentAtRisk": "boolean",
        "partTwo.lineThirtyFive.someInvestmentNotAtRisk": "boolean",
        "partTwo.lineThirtyFour": "number",
        "partTwo.lineThirtyOne": "number",
        "partTwo.lineThirtyThree": "number",
        "partTwo.lineThirtyTwo": "object",
        "partTwo.lineThirtyTwo.f": "array",
        "partTwo.lineThirtyTwo.f[]": "object",
        "partTwo.lineThirtyTwo.f[].amount": "number",
        "partTwo.lineThirtyTwo.f[].description": "string",
        "partTwo.lineThirtyTwo.total": "number",
        "partTwo.lineTwelve": "number",
        "partTwo.lineTwenty": "number",
        "partTwo.lineTwentyEight": "number",
        "partTwo.lineTwentyFive": "number",
        "partTwo.lineTwentyFour": "object",
        "partTwo.lineTwentyFour.a": "number",
        "partTwo.lineTwentyFour.b": "number",
        "partTwo.lineTwentyNine": "number",
        "partTwo.lineTwentyOne": "object",
        "partTwo.lineTwentyOne.a": "number",
        "partTwo.lineTwentyOne.b": "number",
        "partTwo.lineTwentySeven": "number",
        "partTwo.lineTwentySix": "number",
        "partTwo.lineTwentyThree": "number",
        "partTwo.lineTwentyTwo": "number"
    },
    "ScheduleFPageTwoData": {
        "partThree": "object",
        "partThree.lineFifty": "number",
        "partThree.lineForty": "number",
        "partThree.lineFortyEight": "number",
        "partThree.lineFortyFive": "number",
        "partThree.lineFortyFour": "number",
        "partThree.lineFortyNine": "number",
        "partThree.lineFortyOne": "number",
        "partThree.lineFortySeven": "number",
        "partThree.lineFortySix": "number",
        "partThree.lineFortyThree": "number",
        "partThree.lineFortyTwo": "number",
        "partThree.lineThirtyEight": "object",
        "partThree.lineThirtyEight.a": "number",
        "partThree.lineThirtyEight.b": "number",
        "partThree.lineThirtyNine": "object",
        "partThree.lineThirtyNine.a": "number",
        "partThree.lineThirtyNine.b": "number",
        "partThree.lineThirtySeven": "object",
        "partThree.lineThirtySeven.a": "number",
        "partThree.lineThirtySeven.b": "number",
        "partThree.lineThirtySix": "number"
    },
    "ScheduleK1Form1065PageOneData": {
        "partOne": "object",
        "partOne.irsCenter": "string",
        "partOne.partnershipAddress": "object",
        "partOne.partnershipAddress.cityStateZip": "string",
        "partOne.partnershipAddress.street": "string",
        "partOne.partnershipEIN": "string",
        "partOne.partnershipName": "string",
        "partOne.publiclyTradedPartnership": "boolean",
        "partThree": "object",
        "partThree.lineEight": "number",
        "partThree.lineEleven": "number",
        "partThree.lineFive": "number",
        "partThree.lineFour": "object",
        "partThree.lineFour.a": "number",
        "partThree.lineFour.b": "number",
        "partThree.lineFour.c": "number",
        "partThree.lineFourteen": "object",
        "partThree.lineFourteen.a": "number",
        "partThree.lineFourteen.b": "number",
        "partThree.lineFourteen.c": "number",
        "partThree.lineNine": "object",
        "partThree.lineNine.a": "number",
        "partThree.lineNine.b": "number",
        "partThree.lineNine.c": "number",
        "partThree.lineOne": "number",
        "partThree.lineSeven": "number",
        "partThree.lineSix": "object",
        "partThree.lineSix.a": "number",
        "partThree.lineSix.b": "number",
        "partThree.lineSix.c": "number",
        "partThree.lineTen": "number",
        "partThree.lineThirteen": "object",
        "partThree.lineThirteen.items": "array",
        "partThree.lineThirteen.items[]": "object",
        "partThree.lineThree": "number",
        "partThree.lineTwelve": "number",
        "partThree.lineTwo": "number",
        "partTwo": "object",
        "partTwo.capitalAccount": "object",
        "partTwo.capitalAccount.beginningCapitalAccount": "number",
        "partTwo.capitalAccount.capitalContributedDuringYear": "number",
        "partTwo.capitalAccount.currentYearIncrease": "number",
        "partTwo.capitalAccount.endingCapitalAccount": "number",
        "partTwo.capitalAccount.gaapAccounting": "boolean",
        "partTwo.capitalAccount.otherAccounting": "boolean",
        "partTwo.capitalAccount.section704bAccounting": "boolean",
        "partTwo.capitalAccount.taxBasisAccounting": "boolean",
        "partTwo.capitalAccount.unextendedBookTaxDifference": "boolean",
        "partTwo.capitalAccount.withdrawalsAndDistributions": "number",
        "partTwo.capitalSharing": "object",
        "partTwo.capitalSharing.beginning": "number",
        "partTwo.capitalSharing.ending": "number",
        "partTwo.disregardedEntity": "object",
        "partTwo.disregardedEntity.isDisregarded": "boolean",
        "partTwo.disregardedEntity.name": "string",
        "partTwo.disregardedEntity.tin": "string",
        "partTwo.foreignPartner": "boolean",
        "partTwo.liabilities": "object",
        "partTwo.liabilities.nonrecourse": "object",
        "partTwo.liabilities.nonrecourse.beginning": "number",
        "partTwo.liabilities.nonrecourse.ending": "number",
        "partTwo.liabilities.qualifiedNonrecourse": "object",
        "partTwo.liabilities.qualifiedNonrecourse.beginning": "number",
        "partTwo.liabilities.qualifiedNonrecourse.ending": "number",
        "partTwo.liabilities.recourse": "object",
        "partTwo.liabilities.recourse.beginning": "number",
        "partTwo.liabilities.recourse.ending": "number",
        "partTwo.lossSharing": "object",
        "partTwo.lossSharing.beginning": "number",
        "partTwo.lossSharing.ending": "number",
        "partTwo.partnerAddress": "object",
        "partTwo.partnerAddress.cityStateZip": "string",
        "partTwo.partnerAddress.foreignCountry": "string",
        "partTwo.partnerAddress.street": "string",
        "partTwo.partnerName": "string",
        "partTwo.partnerSSNorEIN": "string",
        "partTwo.partnerType": "object",
        "partTwo.partnerType.generalPartner": "boolean",
        "partTwo.partnerType.limitedPartner": "boolean",
        "partTwo.profitSharing": "object",
        "partTwo.profitSharing.beginning": "number",
        "partTwo.profitSharing.ending": "number",
        "partTwo.retirementPlan": "boolean"
    },
    "ScheduleK1Form1065PageThreeData": {
        "attachments": "array",
        "attachments[]": "string",
        "multipleActivities": "boolean",
        "multipleAtRisk": "boolean"
    },
    "ScheduleK1Form1065PageTwoData": {
        "partThreeContinued": "object",
        "partThreeContinued.lineEighteen": "object",
        "partThreeContinued.lineEighteen.items": "array",
        "partThreeContinued.lineEighteen.items[]": "object",
        "partThreeContinued.lineFifteen": "object",
        "partThreeContinued.lineFifteen.items": "array",
        "partThreeContinued.lineFifteen.items[]": "object",
        "partThreeContinued.lineNineteen": "object",
        "partThreeContinued.lineNineteen.a": "number",
        "partThreeContinued.lineNineteen.b": "number",
        "partThreeContinued.lineNineteen.c": "number",
        "partThreeContinued.lineSeventeen": "object",
        "partThreeContinued.lineSeventeen.items": "array",
        "partThreeContinued.lineSeventeen.items[]": "object",
        "partThreeContinued.lineSixteen": "object",
        "partThreeContinued.lineSixteen.items": "array",
        "partThreeContinued.lineSixteen.items[]": "object",
        "partThreeContinued.lineTwenty": "object",
        "partThreeContinued.lineTwenty.items": "array",
        "partThreeContinued.lineTwenty.items[]": "object"
    },
    "ScheduleK1Form1120SPageOneData": {
        "partOne": "object",
        "partOne.corporationAddress": "object",
        "partOne.corporationAddress.cityStateZip": "string",
        "partOne.corporationAddress.street": "string",
        "partOne.corporationEIN": "string",
        "partOne.corporationName": "string",
        "partOne.irsCenter": "string",
        "partThree": "object",
        "partThree.lineEight": "object",
        "partThree.lineEight.a": "number",
        "partThree.lineEight.b": "number",
        "partThree.lineEight.c": "number",
        "partThree.lineEleven": "number",
        "partThree.lineFive": "object",
        "partThree.lineFive.a": "number",
        "partThree.lineFive.b": "number",
        "partThree.lineFour": "number",
        "partThree.lineNine": "number",
        "partThree.lineOne": "number",
        "partThree.lineSeven": "number",
        "partThree.lineSix": "number",
        "partThree.lineTen": "object",
        "partThree.lineTen.items": "array",
        "partThree.lineTen.items[]": "object",
        "partThree.lineThree": "number",
        "partThree.lineTwelve": "object",
        "partThree.lineTwelve.a": "number",
        "partThree.lineTwelve.b": "number",
        "partThree.lineTwelve.c": "number",
        "partThree.lineTwelve.d": "object",
        "partThree.lineTwelve.d.items": "array",
        "partThree.lineTwelve.d.items[]": "object",
        "partThree.lineTwo": "number",
        "partTwo": "object",
        "partTwo.shareholderAddress": "object",
        "partTwo.shareholderAddress.cityStateZip": "string",
        "partTwo.shareholderAddress.foreignCountry": "string",
        "partTwo.shareholderAddress.street": "string",
        "partTwo.shareholderName": "string",
        "partTwo.shareholderPercentOfStock": "object",
        "partTwo.shareholderPercentOfStock.beginningOfYear": "number",
        "partTwo.shareholderPercentOfStock.endOfYear": "number",
        "partTwo.shareholderProRataShare": "object",
        "partTwo.shareholderProRataShare.numberOfSharesBeginning": "number",
        "partTwo.shareholderProRataShare.numberOfSharesEnding": "number",
        "partTwo.shareholderSSNorEIN": "string",
        "partTwo.shareholderShareOfLoans": "object",
        "partTwo.shareholderShareOfLoans.beginningOfYear": "number",
        "partTwo.shareholderShareOfLoans.endOfYear": "number"
    },
    "ScheduleK1Form1120SPageThreeData": {
        "attachments": "array",
        "attachments[]": "string",
        "multipleActivities": "boolean",
        "multipleAtRisk": "boolean",
        "supplementalInformation": "string"
    },
    "ScheduleK1Form1120SPageTwoData": {
        "partThreeContinued": "object",
        "partThreeContinued.lineFifteen": "object",
        "partThreeContinued.lineFifteen.items": "array",
        "partThreeContinued.lineFifteen.items[]": "object",
        "partThreeContinued.lineFourteen": "object",
        "partThreeContinued.lineFourteen.items": "array",
        "partThreeContinued.lineFourteen.items[]": "object",
        "partThreeContinued.lineSeventeen": "object",
        "partThreeContinued.lineSeventeen.items": "array",
        "partThreeContinued.lineSeventeen.items[]": "object",
        "partThreeContinued.lineSixteen": "object",
        "partThreeContinued.lineSixteen.a": "number",
        "partThreeContinued.lineSixteen.b": "number",
        "partThreeContinued.lineSixteen.c": "number",
        "partThreeContinued.lineSixteen.d": "object",
        "partThreeContinued.lineSixteen.d.cash": "number",
        "partThreeContinued.lineSixteen.d.property": "number",
        "partThreeContinued.lineSixteen.e": "number",
        "partThreeContinued.lineThirteen": "object",
        "partThreeContinued.lineThirteen.items": "array",
        "partThreeContinued.lineThirteen.items[]": "object"
    },
    "ScheduleM3Form1065PageFourData": {
        "partThree_continued": "object",
        "partThree_continued.items": "array",
        "partThree_continued.items[]": "object",
        "partThree_continued.lineThirtyNine": "object",
        "partThree_continued.lineThirtyNine.a": "number",
        "partThree_continued.lineThirtyNine.b": "number",
        "partThree_continued.lineThirtyNine.c": "number",
        "partThree_continued.lineThirtyNine.d": "number"
    },
    "ScheduleM3Form1065PageOneData": {
        "header": "object",
        "header.consolidatedGroup": "boolean",
        "header.ein": "string",
        "header.parentCorporation": "object",
        "header.parentCorporation.ein": "string",
        "header.parentCorporation.name": "string",
        "header.partnershipName": "string",
        "partOne": "object",
        "partOne.lineEight": "number",
        "partOne.lineEleven": "number",
        "partOne.lineFive": "object",
        "partOne.lineFive.a": "number",
        "partOne.lineFive.b": "number",
        "partOne.lineFour": "object",
        "partOne.lineFour.a": "number",
        "partOne.lineFour.b": "number",
        "partOne.lineFour.c": "number",
        "partOne.lineFour.d": "number",
        "partOne.lineFour.e": "number",
        "partOne.lineNine": "number",
        "partOne.lineOne": "object",
        "partOne.lineOne.a": "boolean",
        "partOne.lineOne.b": "boolean",
        "partOne.lineOne.c": "boolean",
        "partOne.lineOne.d": "boolean",
        "partOne.lineOne.description": "string",
        "partOne.lineSeven": "object",
        "partOne.lineSeven.a": "number",
        "partOne.lineSeven.b": "number",
        "partOne.lineSix": "object",
        "partOne.lineSix.a": "number",
        "partOne.lineSix.b": "number",
        "partOne.lineTen": "number",
        "partOne.lineThree": "object",
        "partOne.lineThree.attachStatement": "boolean",
        "partOne.lineThree.hasRestated": "boolean",
        "partOne.lineTwelve": "number",
        "partOne.lineTwo": "object",
        "partOne.lineTwo.attachStatement": "boolean",
        "partOne.lineTwo.hasNonConsolidated": "boolean"
    },
    "ScheduleM3Form1065PageThreeData": {
        "partThree": "object",
        "partThree.items": "array",
        "partThree.items[]": "object",
        "partThree.lineThirty": "object",
        "partThree.lineThirty.a": "number",
        "partThree.lineThirty.b": "number",
        "partThree.lineThirty.c": "number",
        "partThree.lineThirty.d": "number"
    },
    "ScheduleM3Form1065PageTwoData": {
        "partTwo": "object",
        "partTwo.items": "array",
        "partTwo.items[]": "object",
        "partTwo.lineThirty": "number",
        "partTwo.lineTwentyNine": "object",
        "partTwo.lineTwentyNine.a": "number",
        "partTwo.lineTwentyNine.b": "number",
        "partTwo.lineTwentyNine.c": "number",
        "partTwo.lineTwentyNine.d": "number"
    },
    "ScheduleM3Form1120PageOneData": {
        "header": "object",
        "header.consolidatedGroup": "object",
        "header.consolidatedGroup.check1120Group": "boolean",
        "header.consolidatedGroup.checkConsolidatedReturn": "boolean",
        "header.consolidatedGroup.checkMixedGroup": "boolean",
        "header.consolidatedGroup.isConsolidated": "boolean",
        "header.consolidatedGroup.parentCorporation": "object",
        "header.consolidatedGroup.parentCorporation.ein": "string",
        "header.consolidatedGroup.parentCorporation.name": "string",
        "header.corporationName": "string",
        "header.ein": "string",
        "partOne": "object",
        "partOne.lineEight": "number",
        "partOne.lineEleven": "number",
        "partOne.lineFive": "object",
        "partOne.lineFive.a": "number",
        "partOne.lineFive.b": "number",
        "partOne.lineFour": "object",
        "partOne.lineFour.a": "number",
        "partOne.lineFour.b": "number",
        "partOne.lineNine": "number",
        "partOne.lineOne": "object",
        "partOne.lineOne.a": "boolean",
        "partOne.lineOne.b": "boolean",
        "partOne.lineOne.c": "boolean",
        "partOne.lineOne.d": "boolean",
        "partOne.lineOne.description": "string",
        "partOne.lineSeven": "object",
        "partOne.lineSeven.a": "number",
        "partOne.lineSeven.b": "number",
        "partOne.lineSeven.c": "number",
        "partOne.lineSix": "object",
        "partOne.lineSix.a": "number",
        "partOne.lineSix.b": "number",
        "partOne.lineTen": "object",
        "partOne.lineTen.a": "number",
        "partOne.lineTen.b": "number",
        "partOne.lineTen.c": "number",
        "partOne.lineThree": "object",
        "partOne.lineThree.attachStatement": "boolean",
        "partOne.lineThree.hasRestated": "boolean",
        "partOne.lineTwelve": "object",
        "partOne.lineTwelve.amount": "number",
        "partOne.lineTwelve.checkBox": "boolean",
        "partOne.lineTwo": "object",
        "partOne.lineTwo.attachStatement": "boolean",
        "partOne.lineTwo.hasNonConsolidated": "boolean"
    },
    "ScheduleM3Form1120PageThreeData": {
        "partThree_continued": "object",
        "partThree_continued.items": "array",
        "partThree_continued.items[]": "object",
        "partThree_continued.lineThirtyEight": "object",
        "partThree_continued.lineThirtyEight.a": "number",
        "partThree_continued.lineThirtyEight.b": "number",
        "partThree_continued.lineThirtyEight.c": "number",
        "partThree_continued.lineThirtyEight.d": "number",
        "partThree_continued.lineThirtySeven": "object",
        "partThree_continued.lineThirtySeven.a": "number",
        "partThree_continued.lineThirtySeven.d": "number",
        "partThree_continued.lineThirtySix": "object",
        "partThree_continued.lineThirtySix.a": "number",
        "partThree_continued.lineThirtySix.b": "number",
        "partThree_continued.lineThirtySix.c": "number",
        "partThree_continued.lineThirtySix.d": "number"
    },
    "ScheduleM3Form1120PageTwoData": {
        "partThree": "object",
        "partThree.items": "array",
        "partThree.items[]": "object",
        "partTwo": "object",
        "partTwo.items": "array",
        "partTwo.items[]": "object",
        "partTwo.lineThirty": "object",
        "partTwo.lineThirty.a": "number",
        "partTwo.lineThirty.b": "number",
        "partTwo.lineThirty.c": "number",
        "partTwo.lineThirty.d": "number"
    },
    "ScheduleM3Form1120SPageOneData": {
        "header": "object",
        "header.corporationName": "string",
        "header.ein": "string",
        "partOne": "object",
        "partOne.lineEight": "number",
        "partOne.lineEleven": "number",
        "partOne.lineFive": "object",
        "partOne.lineFive.a": "number",
        "partOne.lineFive.b": "number",
        "partOne.lineFour": "object",
        "partOne.lineFour.a": "number",
        "partOne.lineFour.b": "number",
        "partOne.lineNine": "number",
        "partOne.lineOne": "object",
        "partOne.lineOne.a": "boolean",
        "partOne.lineOne.b": "boolean",
        "partOne.lineOne.c": "boolean",
        "partOne.lineOne.d": "boolean",
        "partOne.lineOne.description": "string",
        "partOne.lineSeven": "object",
        "partOne.lineSeven.a": "number",
        "partOne.lineSeven.b": "number",
        "partOne.lineSeven.c": "number",
        "partOne.lineSix": "object",
        "partOne.lineSix.a": "number",
        "partOne.lineSix.b": "number",
        "partOne.lineTen": "object",
        "partOne.lineTen.a": "number",
        "partOne.lineTen.b": "number",
        "partOne.lineTen.c": "number",
        "partOne.lineThree": "object",
        "partOne.lineThree.attachStatement": "boolean",
        "partOne.lineThree.hasRestated": "boolean",
        "partOne.lineTwelve": "object",
        "partOne.lineTwelve.amount": "number",
        "partOne.lineTwelve.checkBox": "boolean",
        "partOne.lineTwo": "object",
        "partOne.lineTwo.attachStatement": "boolean",
        "partOne.lineTwo.hasNonConsolidated": "boolean"
    },
    "ScheduleM3Form1120SPageThreeData": {
        "partThree_continued": "object",
        "partThree_continued.items": "array",
        "partThree_continued.items[]": "object",
        "partThree_continued.lineThirtyOne": "object",
        "partThree_continued.lineThirtyOne.a": "number",
        "partThree_continued.lineThirtyOne.b": "number",
        "partThree_continued.lineThirtyOne.c": "number",
        "partThree_continued.lineThirtyOne.d": "number",
        "partThree_continued.lineThirtyThree": "object",
        "partThree_continued.lineThirtyThree.a": "number",
        "partThree_continued.lineThirtyThree.b": "number",
        "partThree_continued.lineThirtyThree.c": "number",
        "partThree_continued.lineThirtyThree.d": "number",
        "partThree_continued.lineThirtyTwo": "object",
        "partThree_continued.lineThirtyTwo.a": "number",
        "partThree_continued.lineThirtyTwo.d": "number"
    },
    "ScheduleM3Form1120SPageTwoData": {
        "partThree": "object",
        "partThree.items": "array",
        "partThree.items[]": "object",
        "partTwo": "object",
        "partTwo.items": "array",
        "partTwo.items[]": "object",
        "partTwo.lineThirty": "object",
        "partTwo.lineThirty.a": "number",
        "partTwo.lineThirty.b": "number",
        "partTwo.lineThirty.c": "number",
        "partTwo.lineThirty.d": "number"
    },
    "ShortTermTransaction": {
        "adjustmentAmount": "number",
        "adjustmentCode": "string",
        "costBasis": "number",
        "dateAcquired": "string",
        "dateSold": "string",
        "description": "string",
        "gainOrLoss": "number",
        "proceeds": "number"
    },
    "TaxExemptItem": {
        "amount": "number",
        "code": "string",
        "description": "string"
    }
};

/**
 * Literal type for all possible field types
 */
export type FieldType = 'string' | 'number' | 'boolean' | 'array' | 'object' | 'null' | 'undefined' | 'any' | 'unknown' | 'union' | 'literal' | 'void';

/**
 * Get the type of a field at a given path in a form interface
 * @param formName The name of the form interface (e.g., 'Form1040PageOneData')
 * @param path The dot-notation path to the field (e.g., 'income.one.a')
 * @returns The type of the field as a string literal type, or 'unknown' if not found
 */
export function getFormFieldType<T extends keyof typeof formTypeDefinitions>(
    formName: T,
    path: string
): FieldType {
    const formSchema = formTypeDefinitions[formName];

    if (!formSchema) {
        return 'unknown';
    }

    // Check for exact match first
    if (formSchema[path]) {
        return formSchema[path] as FieldType;
    }

    // Check for array element access (e.g., 'dependents[0].firstName')
    const arrayAccessPattern = /\[(\d+)\]/g;
    const normalizedPath = path.replace(arrayAccessPattern, '[]');

    if (formSchema[normalizedPath]) {
        return formSchema[normalizedPath] as FieldType;
    }

    // If still not found, try to infer from parent
    const segments = path.split('.');
    while (segments.length > 0) {
        segments.pop();
        const parentPath = segments.join('.');
        if (formSchema[parentPath]) {
            // If parent is an object or array, the child might exist but not be defined
            if (formSchema[parentPath] === 'object' || formSchema[parentPath] === 'array') {
                return 'unknown';
            }
        }
    }

    return 'unknown';
}

/**
 * Get all available paths for a given form
 * @param formName The name of the form interface
 * @returns Array of all available paths in the form
 */
export function getFormPaths<T extends keyof typeof formTypeDefinitions>(
    formName: T
): string[] {
    const formSchema = formTypeDefinitions[formName];

    if (!formSchema) {
        return [];
    }

    return Object.keys(formSchema);
}

/**
 * Get all available form names
 * @returns Array of all form interface names
 */
export function getAvailableFormNames(): string[] {
    return Object.keys(formTypeDefinitions);
}

/**
 * Check if a form exists in the type definitions
 * @param formName The name of the form to check
 * @returns true if the form exists, false otherwise
 */
export function hasForm(formName: string): formName is keyof typeof formTypeDefinitions {
    return formName in formTypeDefinitions;
}

/**
 * Get type information for all fields in a form matching a pattern
 * @param formName The name of the form interface
 * @param pattern A regex pattern to match field paths
 * @returns Object mapping matching paths to their types
 */
export function getMatchingFields<T extends keyof typeof formTypeDefinitions>(
    formName: T,
    pattern: RegExp
): Record<string, FieldType> {
    const formSchema = formTypeDefinitions[formName];

    if (!formSchema) {
        return {};
    }

    const matching: Record<string, FieldType> = {};

    for (const [path, type] of Object.entries(formSchema)) {
        if (pattern.test(path)) {
            matching[path] = type as FieldType;
        }
    }

    return matching;
}

// Export type utilities for use in TypeScript code
export type FormName = keyof typeof formTypeDefinitions;
export type FormFieldPath<T extends FormName> = keyof typeof formTypeDefinitions[T];
export type FormFieldType<T extends FormName, P extends FormFieldPath<T>> =
    typeof formTypeDefinitions[T][P];
